// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./themes.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 stroke=%27black%27 viewBox=%270 0 24 24%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg transform-origin=%27center%27%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%279.5%27 fill=%27none%27 stroke-width=%273%27 stroke-linecap=%27round%27%3E%3CanimateTransform attributeName=%27transform%27 type=%27rotate%27 from=%270 12 12%27 to=%27360 12 12%27 dur=%272s%27 repeatCount=%27indefinite%27/%3E%3Canimate attributeName=%27stroke-dasharray%27 values=%270,150;42,150;42,150%27 keyTimes=%270;0.475;1%27 dur=%271.5s%27 repeatCount=%27indefinite%27/%3E%3Canimate attributeName=%27stroke-dashoffset%27 values=%270;-16;-59%27 keyTimes=%270;0.475;1%27 dur=%271.5s%27 repeatCount=%27indefinite%27/%3E%3C/circle%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/app-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root,
[data-theme] {
  background-color: var(--fallback-b1,oklch(var(--b1)/1));
  color: var(--fallback-bc,oklch(var(--bc)/1));
}

@supports not (color: oklch(0% 0 0)) {

  :root {
    color-scheme: light;
    --fallback-p: #491eff;
    --fallback-pc: #d4dbff;
    --fallback-s: #ff41c7;
    --fallback-sc: #fff9fc;
    --fallback-a: #00cfbd;
    --fallback-ac: #00100d;
    --fallback-n: #2b3440;
    --fallback-nc: #d7dde4;
    --fallback-b1: #ffffff;
    --fallback-b2: #e5e6e6;
    --fallback-b3: #e5e6e6;
    --fallback-bc: #1f2937;
    --fallback-in: #00b3f0;
    --fallback-inc: #000000;
    --fallback-su: #00ca92;
    --fallback-suc: #000000;
    --fallback-wa: #ffc22d;
    --fallback-wac: #000000;
    --fallback-er: #ff6f70;
    --fallback-erc: #000000;
  }

  @media (prefers-color-scheme: dark) {

    :root {
      color-scheme: dark;
      --fallback-p: #7582ff;
      --fallback-pc: #050617;
      --fallback-s: #ff71cf;
      --fallback-sc: #190211;
      --fallback-a: #00c7b5;
      --fallback-ac: #000e0c;
      --fallback-n: #2a323c;
      --fallback-nc: #a6adbb;
      --fallback-b1: #1d232a;
      --fallback-b2: #191e24;
      --fallback-b3: #15191e;
      --fallback-bc: #a6adbb;
      --fallback-in: #00b3f0;
      --fallback-inc: #000000;
      --fallback-su: #00ca92;
      --fallback-suc: #000000;
      --fallback-wa: #ffc22d;
      --fallback-wac: #000000;
      --fallback-er: #ff6f70;
      --fallback-erc: #000000;
    }
  }
}

html {
  -webkit-tap-highlight-color: transparent;
}

* {
  scrollbar-color: color-mix(in oklch, currentColor 35%, transparent) transparent;
}

*:hover {
  scrollbar-color: color-mix(in oklch, currentColor 60%, transparent) transparent;
}

:root {
  color-scheme: light;
  --in: 72.06% 0.191 231.6;
  --su: 64.8% 0.150 160;
  --wa: 84.71% 0.199 83.87;
  --er: 71.76% 0.221 22.18;
  --pc: 89.824% 0.06192 275.75;
  --ac: 15.352% 0.0368 183.61;
  --inc: 0% 0 0;
  --suc: 0% 0 0;
  --wac: 0% 0 0;
  --erc: 0% 0 0;
  --rounded-box: 1rem;
  --rounded-btn: 0.5rem;
  --rounded-badge: 1.9rem;
  --animation-btn: 0.25s;
  --animation-input: .2s;
  --btn-focus-scale: 0.95;
  --border-btn: 1px;
  --tab-border: 1px;
  --tab-radius: 0.5rem;
  --p: 49.12% 0.3096 275.75;
  --s: 69.71% 0.329 342.55;
  --sc: 98.71% 0.0106 342.55;
  --a: 76.76% 0.184 183.61;
  --n: 32.1785% 0.02476 255.701624;
  --nc: 89.4994% 0.011585 252.096176;
  --b1: 100% 0 0;
  --b2: 96.1151% 0 0;
  --b3: 92.4169% 0.00108 197.137559;
  --bc: 27.8078% 0.029596 256.847952;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.alert {
  display: grid;
  width: 100%;
  grid-auto-flow: row;
  align-content: flex-start;
  align-items: center;
  justify-items: center;
  gap: 1rem;
  text-align: center;
  border-radius: var(--rounded-box, 1rem);
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-border-opacity)));
  padding: 1rem;
  --tw-text-opacity: 1;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
  --alert-bg: var(--fallback-b2,oklch(var(--b2)/1));
  --alert-bg-mix: var(--fallback-b1,oklch(var(--b1)/1));
  background-color: var(--alert-bg);
}
@media (min-width: 640px) {

  .alert {
    grid-auto-flow: column;
    grid-template-columns: auto minmax(auto,1fr);
    justify-items: start;
    text-align: start;
  }
}
.artboard {
  width: 100%;
}
@media (hover:hover) {

  .label a:hover {
    --tw-text-opacity: 1;
    color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
  }

  .menu li > *:not(ul, .menu-title, details, .btn):active,
.menu li > *:not(ul, .menu-title, details, .btn).active,
.menu li > details > summary:active {
    --tw-bg-opacity: 1;
    background-color: var(--fallback-n,oklch(var(--n)/var(--tw-bg-opacity)));
    --tw-text-opacity: 1;
    color: var(--fallback-nc,oklch(var(--nc)/var(--tw-text-opacity)));
  }

  .tab:hover {
    --tw-text-opacity: 1;
  }
}
.carousel {
  display: inline-flex;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.checkbox {
  flex-shrink: 0;
  --chkbg: var(--fallback-bc,oklch(var(--bc)/1));
  --chkfg: var(--fallback-b1,oklch(var(--b1)/1));
  height: 1.5rem;
  width: 1.5rem;
  cursor: pointer;
  appearance: none;
  border-radius: var(--rounded-btn, 0.5rem);
  border-width: 1px;
  border-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-border-opacity)));
  --tw-border-opacity: 0.2;
}
.collapse:not(td):not(tr):not(colgroup) {
  visibility: visible;
}
.collapse {
  position: relative;
  display: grid;
  overflow: hidden;
  grid-template-rows: max-content 0fr;
  transition: grid-template-rows 0.2s;
  width: 100%;
  border-radius: var(--rounded-box, 1rem);
}
.collapse-title,
.collapse > input[type="checkbox"],
.collapse > input[type="radio"],
.collapse-content {
  grid-column-start: 1;
  grid-row-start: 1;
}
.collapse > input[type="checkbox"],
.collapse > input[type="radio"] {
  appearance: none;
  opacity: 0;
}
:where(.collapse > input[type="checkbox"]),
:where(.collapse > input[type="radio"]) {
  height: 100%;
  width: 100%;
  z-index: 1;
}
.collapse-content {
  visibility: hidden;
  grid-column-start: 1;
  grid-row-start: 2;
  min-height: 0px;
  transition: visibility 0.2s;
  transition: padding 0.2s ease-out,
    background-color 0.2s ease-out;
  padding-left: 1rem;
  padding-right: 1rem;
  cursor: unset;
}
.collapse[open],
.collapse-open,
.collapse:focus:not(.collapse-close) {
  grid-template-rows: max-content 1fr;
}
.collapse:not(.collapse-close):has(> input[type="checkbox"]:checked),
.collapse:not(.collapse-close):has(> input[type="radio"]:checked) {
  grid-template-rows: max-content 1fr;
}
.collapse[open] > .collapse-content,
.collapse-open > .collapse-content,
.collapse:focus:not(.collapse-close) > .collapse-content,
.collapse:not(.collapse-close) > input[type="checkbox"]:checked ~ .collapse-content,
.collapse:not(.collapse-close) > input[type="radio"]:checked ~ .collapse-content {
  visibility: visible;
  min-height: fit-content;
}
@media (hover: hover) {

  .btm-nav > *.disabled:hover,
      .btm-nav > *[disabled]:hover {
    pointer-events: none;
    --tw-border-opacity: 0;
    background-color: var(--fallback-n,oklch(var(--n)/var(--tw-bg-opacity)));
    --tw-bg-opacity: 0.1;
    color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
    --tw-text-opacity: 0.2;
  }

  :where(.menu li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title)):not(.active, .btn):hover, :where(.menu li:not(.menu-title, .disabled) > details > summary:not(.menu-title)):not(.active, .btn):hover {
    cursor: pointer;
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  @supports (color: oklch(0% 0 0)) {

    :where(.menu li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title)):not(.active, .btn):hover, :where(.menu li:not(.menu-title, .disabled) > details > summary:not(.menu-title)):not(.active, .btn):hover {
      background-color: var(--fallback-bc,oklch(var(--bc)/0.1));
    }
  }

  .tab[disabled],
    .tab[disabled]:hover {
    cursor: not-allowed;
    color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
    --tw-text-opacity: 0.2;
  }
}
.label {
  display: flex;
  -webkit-user-select: none;
          user-select: none;
  align-items: center;
  justify-content: space-between;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.input {
  flex-shrink: 1;
  appearance: none;
  height: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 1rem;
  line-height: 2;
  line-height: 1.5rem;
  border-radius: var(--rounded-btn, 0.5rem);
  border-width: 1px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
}
.input[type="number"]::-webkit-inner-spin-button,
.input-md[type="number"]::-webkit-inner-spin-button {
  margin-top: -1rem;
  margin-bottom: -1rem;
  margin-inline-end: -1rem;
}
.link {
  cursor: pointer;
  text-decoration-line: underline;
}
.menu {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 0.5rem;
}
.menu :where(li ul) {
  position: relative;
  white-space: nowrap;
  margin-inline-start: 1rem;
  padding-inline-start: 0.5rem;
}
.menu :where(li:not(.menu-title) > *:not(ul, details, .menu-title, .btn)), .menu :where(li:not(.menu-title) > details > summary:not(.menu-title)) {
  display: grid;
  grid-auto-flow: column;
  align-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  grid-auto-columns: minmax(auto, max-content) auto max-content;
  -webkit-user-select: none;
          user-select: none;
}
.menu li.disabled {
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
  color: var(--fallback-bc,oklch(var(--bc)/0.3));
}
.menu :where(li > .menu-dropdown:not(.menu-dropdown-show)) {
  display: none;
}
:where(.menu li) {
  position: relative;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: stretch;
}
:where(.menu li) .badge {
  justify-self: end;
}
.navbar {
  display: flex;
  align-items: center;
  padding: var(--navbar-padding, 0.5rem);
  min-height: 4rem;
  width: 100%;
}
:where(.navbar > *:not(script, style)) {
  display: inline-flex;
  align-items: center;
}
.radio {
  flex-shrink: 0;
  --chkbg: var(--bc);
  height: 1.5rem;
  width: 1.5rem;
  cursor: pointer;
  appearance: none;
  border-radius: 9999px;
  border-width: 1px;
  border-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-border-opacity)));
  --tw-border-opacity: 0.2;
}
.steps {
  display: inline-grid;
  grid-auto-flow: column;
  overflow: hidden;
  overflow-x: auto;
  counter-reset: step;
  grid-auto-columns: 1fr;
}
.steps .step {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-template-columns: auto;
  grid-template-rows: repeat(2, minmax(0, 1fr));
  grid-template-rows: 40px 1fr;
  place-items: center;
  text-align: center;
  min-width: 4rem;
}
.tabs {
  display: grid;
  align-items: flex-end;
}
.tabs-lifted:has(.tab-content[class^="rounded-"])
    .tab:first-child:not(:is(.tab-active, [aria-selected="true"])), .tabs-lifted:has(.tab-content[class*=" rounded-"])
    .tab:first-child:not(:is(.tab-active, [aria-selected="true"])) {
  border-bottom-color: transparent;
}
.tab {
  position: relative;
  grid-row-start: 1;
  display: inline-flex;
  height: 2rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  appearance: none;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
  --tab-padding: 1rem;
  --tw-text-opacity: 0.5;
  --tab-color: var(--fallback-bc,oklch(var(--bc)/1));
  --tab-bg: var(--fallback-b1,oklch(var(--b1)/1));
  --tab-border-color: var(--fallback-b3,oklch(var(--b3)/1));
  color: var(--tab-color);
  padding-inline-start: var(--tab-padding, 1rem);
  padding-inline-end: var(--tab-padding, 1rem);
}
.tab:is(input[type="radio"]) {
  width: auto;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.tab:is(input[type="radio"]):after {
  --tw-content: attr(aria-label);
  content: var(--tw-content);
}
.tab:not(input):empty {
  cursor: default;
  grid-column-start: span 9999;
}
.tab-content {
  grid-column-start: 1;
  grid-column-end: span 9999;
  grid-row-start: 2;
  margin-top: calc(var(--tab-border) * -1);
  display: none;
  border-color: transparent;
  border-width: var(--tab-border, 0);
}
:checked + .tab-content:nth-child(2),
  :is(.tab-active, [aria-selected="true"]) + .tab-content:nth-child(2) {
  border-start-start-radius: 0px;
}
input.tab:checked + .tab-content,
:is(.tab-active, [aria-selected="true"]) + .tab-content {
  display: block;
}
.textarea {
  min-height: 3rem;
  flex-shrink: 1;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
  border-radius: var(--rounded-btn, 0.5rem);
  border-width: 1px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
}
.alert-error {
  border-color: var(--fallback-er,oklch(var(--er)/0.2));
  --tw-text-opacity: 1;
  color: var(--fallback-erc,oklch(var(--erc)/var(--tw-text-opacity)));
  --alert-bg: var(--fallback-er,oklch(var(--er)/1));
  --alert-bg-mix: var(--fallback-b1,oklch(var(--b1)/1));
}
.btm-nav > *:where(.active) {
  border-top-width: 2px;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
}
.btm-nav > *.disabled,
    .btm-nav > *[disabled] {
  pointer-events: none;
  --tw-border-opacity: 0;
  background-color: var(--fallback-n,oklch(var(--n)/var(--tw-bg-opacity)));
  --tw-bg-opacity: 0.1;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
  --tw-text-opacity: 0.2;
}
.btm-nav > * .label {
  font-size: 1rem;
  line-height: 1.5rem;
}
@keyframes button-pop {

  0% {
    transform: scale(var(--btn-focus-scale, 0.98));
  }

  40% {
    transform: scale(1.02);
  }

  100% {
    transform: scale(1);
  }
}
.carousel::-webkit-scrollbar {
  display: none;
}
.checkbox:focus {
  box-shadow: none;
}
.checkbox:focus-visible {
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: var(--fallback-bc,oklch(var(--bc)/1));
}
.checkbox:disabled {
  border-width: 0px;
  cursor: not-allowed;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-bg-opacity)));
  opacity: 0.2;
}
.checkbox:checked,
  .checkbox[aria-checked="true"] {
  background-repeat: no-repeat;
  animation: checkmark var(--animation-input, 0.2s) ease-out;
  background-color: var(--chkbg);
  background-image: linear-gradient(-45deg, transparent 65%, var(--chkbg) 65.99%),
      linear-gradient(45deg, transparent 75%, var(--chkbg) 75.99%),
      linear-gradient(-45deg, var(--chkbg) 40%, transparent 40.99%),
      linear-gradient(
        45deg,
        var(--chkbg) 30%,
        var(--chkfg) 30.99%,
        var(--chkfg) 40%,
        transparent 40.99%
      ),
      linear-gradient(-45deg, var(--chkfg) 50%, var(--chkbg) 50.99%);
}
.checkbox:indeterminate {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-bg-opacity)));
  background-repeat: no-repeat;
  animation: checkmark var(--animation-input, 0.2s) ease-out;
  background-image: linear-gradient(90deg, transparent 80%, var(--chkbg) 80%),
      linear-gradient(-90deg, transparent 80%, var(--chkbg) 80%),
      linear-gradient(0deg, var(--chkbg) 43%, var(--chkfg) 43%, var(--chkfg) 57%, var(--chkbg) 57%);
}
@keyframes checkmark {

  0% {
    background-position-y: 5px;
  }

  50% {
    background-position-y: -2px;
  }

  100% {
    background-position-y: 0;
  }
}
details.collapse {
  width: 100%;
}
details.collapse summary {
  position: relative;
  display: block;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
details.collapse summary::-webkit-details-marker {
  display: none;
}
.collapse:focus-visible {
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: var(--fallback-bc,oklch(var(--bc)/1));
}
.collapse:has(.collapse-title:focus-visible),
.collapse:has(> input[type="checkbox"]:focus-visible),
.collapse:has(> input[type="radio"]:focus-visible) {
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: var(--fallback-bc,oklch(var(--bc)/1));
}
.collapse-arrow > .collapse-title:after {
  position: absolute;
  display: block;
  height: 0.5rem;
  width: 0.5rem;
  --tw-translate-y: -100%;
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 150ms;
  transition-duration: 0.2s;
  top: 1.9rem;
  inset-inline-end: 1.4rem;
  content: "";
  transform-origin: 75% 75%;
  box-shadow: 2px 2px;
  pointer-events: none;
}
.collapse-plus > .collapse-title:after {
  position: absolute;
  display: block;
  height: 0.5rem;
  width: 0.5rem;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 300ms;
  top: 0.9rem;
  inset-inline-end: 1.4rem;
  content: "+";
  pointer-events: none;
}
.collapse:not(.collapse-open):not(.collapse-close) > input[type="checkbox"],
.collapse:not(.collapse-open):not(.collapse-close) > input[type="radio"]:not(:checked),
.collapse:not(.collapse-open):not(.collapse-close) > .collapse-title {
  cursor: pointer;
}
.collapse:focus:not(.collapse-open):not(.collapse-close):not(.collapse[open]) > .collapse-title {
  cursor: unset;
}
.collapse-title {
  position: relative;
}
.collapse-title,
:where(.collapse > input[type="checkbox"]),
:where(.collapse > input[type="radio"]) {
  padding: 1rem;
  padding-inline-end: 3rem;
  min-height: 3.75rem;
  transition: background-color 0.2s ease-out;
}
.collapse[open] > :where(.collapse-content),
.collapse-open > :where(.collapse-content),
.collapse:focus:not(.collapse-close) > :where(.collapse-content),
.collapse:not(.collapse-close) > :where(input[type="checkbox"]:checked ~ .collapse-content),
.collapse:not(.collapse-close) > :where(input[type="radio"]:checked ~ .collapse-content) {
  padding-bottom: 1rem;
  transition: padding 0.2s ease-out,
    background-color 0.2s ease-out;
}
.collapse[open].collapse-arrow > .collapse-title:after,
.collapse-open.collapse-arrow > .collapse-title:after,
.collapse-arrow:focus:not(.collapse-close) > .collapse-title:after,
.collapse-arrow:not(.collapse-close) > input[type="checkbox"]:checked ~ .collapse-title:after,
.collapse-arrow:not(.collapse-close) > input[type="radio"]:checked ~ .collapse-title:after {
  --tw-translate-y: -50%;
  --tw-rotate: 225deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.collapse[open].collapse-plus > .collapse-title:after,
.collapse-open.collapse-plus > .collapse-title:after,
.collapse-plus:focus:not(.collapse-close) > .collapse-title:after,
.collapse-plus:not(.collapse-close) > input[type="checkbox"]:checked ~ .collapse-title:after,
.collapse-plus:not(.collapse-close) > input[type="radio"]:checked ~ .collapse-title:after {
  content: "−";
}
.input input {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-p,oklch(var(--p)/var(--tw-bg-opacity)));
  background-color: transparent;
}
.input input:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.input[list]::-webkit-calendar-picker-indicator {
  line-height: 1em;
}
.input:focus,
  .input:focus-within {
  box-shadow: none;
  border-color: var(--fallback-bc,oklch(var(--bc)/0.2));
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: var(--fallback-bc,oklch(var(--bc)/0.2));
}
.input:has(> input[disabled]),
  .input-disabled,
  .input:disabled,
  .input[disabled] {
  cursor: not-allowed;
  --tw-border-opacity: 1;
  border-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-border-opacity)));
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-bg-opacity)));
  color: var(--fallback-bc,oklch(var(--bc)/0.4));
}
.input:has(> input[disabled])::placeholder,
  .input-disabled::placeholder,
  .input:disabled::placeholder,
  .input[disabled]::placeholder {
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-placeholder-opacity)));
  --tw-placeholder-opacity: 0.2;
}
.input:has(> input[disabled]) > input[disabled] {
  cursor: not-allowed;
}
.input::-webkit-date-and-time-value {
  text-align: inherit;
}
.link:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.link:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}
.loading {
  pointer-events: none;
  display: inline-block;
  aspect-ratio: 1 / 1;
  width: 1.5rem;
  background-color: currentColor;
  mask-size: 100%;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
:where(.menu li:empty) {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-bg-opacity)));
  opacity: 0.1;
  margin: 0.5rem 1rem;
  height: 1px;
}
.menu :where(li ul):before {
  position: absolute;
  bottom: 0.75rem;
  inset-inline-start: 0px;
  top: 0.75rem;
  width: 1px;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-bg-opacity)));
  opacity: 0.1;
  content: "";
}
.menu :where(li:not(.menu-title) > *:not(ul, details, .menu-title, .btn)),
.menu :where(li:not(.menu-title) > details > summary:not(.menu-title)) {
  border-radius: var(--rounded-btn, 0.5rem);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: start;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 200ms;
  text-wrap: balance;
}
:where(.menu li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title)):not(summary, .active, .btn).focus, :where(.menu li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title)):not(summary, .active, .btn):focus, :where(.menu li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title)):is(summary):not(.active, .btn):focus-visible, :where(.menu li:not(.menu-title, .disabled) > details > summary:not(.menu-title)):not(summary, .active, .btn).focus, :where(.menu li:not(.menu-title, .disabled) > details > summary:not(.menu-title)):not(summary, .active, .btn):focus, :where(.menu li:not(.menu-title, .disabled) > details > summary:not(.menu-title)):is(summary):not(.active, .btn):focus-visible {
  cursor: pointer;
  background-color: var(--fallback-bc,oklch(var(--bc)/0.1));
  --tw-text-opacity: 1;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.menu li > *:not(ul, .menu-title, details, .btn):active,
.menu li > *:not(ul, .menu-title, details, .btn).active,
.menu li > details > summary:active {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-n,oklch(var(--n)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-nc,oklch(var(--nc)/var(--tw-text-opacity)));
}
.menu :where(li > details > summary)::-webkit-details-marker {
  display: none;
}
.menu :where(li > details > summary):after,
.menu :where(li > .menu-dropdown-toggle):after {
  justify-self: end;
  display: block;
  margin-top: -0.5rem;
  height: 0.5rem;
  width: 0.5rem;
  transform: rotate(45deg);
  transition-property: transform, margin-top;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  content: "";
  transform-origin: 75% 75%;
  box-shadow: 2px 2px;
  pointer-events: none;
}
.menu :where(li > details[open] > summary):after,
.menu :where(li > .menu-dropdown-toggle.menu-dropdown-show):after {
  transform: rotate(225deg);
  margin-top: 0;
}
.mockup-phone {
  display: inline-block;
  border: 4px solid #444;
  border-radius: 50px;
  background-color: #000;
  padding: 10px;
  margin: 0 auto;
  overflow: hidden;
}
.mockup-phone .camera {
  position: relative;
  top: 0px;
  left: 0px;
  background: #000;
  height: 25px;
  width: 150px;
  margin: 0 auto;
  border-bottom-left-radius: 17px;
  border-bottom-right-radius: 17px;
  z-index: 11;
}
.mockup-phone .camera:before {
  content: "";
  position: absolute;
  top: 35%;
  left: 50%;
  width: 50px;
  height: 4px;
  border-radius: 5px;
  background-color: #0c0b0e;
  transform: translate(-50%, -50%);
}
.mockup-phone .camera:after {
  content: "";
  position: absolute;
  top: 20%;
  left: 70%;
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background-color: #0f0b25;
}
.mockup-phone .display {
  overflow: hidden;
  border-radius: 40px;
  margin-top: -25px;
}
.mockup-browser .mockup-browser-toolbar .input {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: block;
  height: 1.75rem;
  width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-bg-opacity)));
  padding-left: 2rem;
  direction: ltr;
}
.mockup-browser .mockup-browser-toolbar .input:before {
  content: "";
  position: absolute;
  left: 0.5rem;
  top: 50%;
  aspect-ratio: 1 / 1;
  height: 0.75rem;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 9999px;
  border-width: 2px;
  border-color: currentColor;
  opacity: 0.6;
}
.mockup-browser .mockup-browser-toolbar .input:after {
  content: "";
  position: absolute;
  left: 1.25rem;
  top: 50%;
  height: 0.5rem;
  --tw-translate-y: 25%;
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 9999px;
  border-width: 1px;
  border-color: currentColor;
  opacity: 0.6;
}
@keyframes modal-pop {

  0% {
    opacity: 0;
  }
}
@keyframes progress-loading {

  50% {
    background-position-x: -115%;
  }
}
.radio:focus {
  box-shadow: none;
}
.radio:focus-visible {
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: var(--fallback-bc,oklch(var(--bc)/1));
}
.radio:checked,
  .radio[aria-checked="true"] {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-bg-opacity)));
  background-image: none;
  animation: radiomark var(--animation-input, 0.2s) ease-out;
  box-shadow: 0 0 0 4px var(--fallback-b1,oklch(var(--b1)/1)) inset,
      0 0 0 4px var(--fallback-b1,oklch(var(--b1)/1)) inset;
}
.radio:disabled {
  cursor: not-allowed;
  opacity: 0.2;
}
@keyframes radiomark {

  0% {
    box-shadow: 0 0 0 12px var(--fallback-b1,oklch(var(--b1)/1)) inset,
      0 0 0 12px var(--fallback-b1,oklch(var(--b1)/1)) inset;
  }

  50% {
    box-shadow: 0 0 0 3px var(--fallback-b1,oklch(var(--b1)/1)) inset,
      0 0 0 3px var(--fallback-b1,oklch(var(--b1)/1)) inset;
  }

  100% {
    box-shadow: 0 0 0 4px var(--fallback-b1,oklch(var(--b1)/1)) inset,
      0 0 0 4px var(--fallback-b1,oklch(var(--b1)/1)) inset;
  }
}
@keyframes rating-pop {

  0% {
    transform: translateY(-0.125em);
  }

  40% {
    transform: translateY(-0.125em);
  }

  100% {
    transform: translateY(0);
  }
}
@keyframes skeleton {

  from {
    background-position: 150%;
  }

  to {
    background-position: -50%;
  }
}
.steps .step:before {
  top: 0px;
  grid-column-start: 1;
  grid-row-start: 1;
  height: 0.5rem;
  width: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b3,oklch(var(--b3)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
  content: "";
  margin-inline-start: -100%;
}
.steps .step:after {
  content: counter(step);
  counter-increment: step;
  z-index: 1;
  position: relative;
  grid-column-start: 1;
  grid-row-start: 1;
  display: grid;
  height: 2rem;
  width: 2rem;
  place-items: center;
  place-self: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b3,oklch(var(--b3)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
}
.steps .step:first-child:before {
  content: none;
}
.steps .step[data-content]:after {
  content: attr(data-content);
}
.steps .step-neutral + .step-neutral:before,
  .steps .step-neutral:after {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-n,oklch(var(--n)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-nc,oklch(var(--nc)/var(--tw-text-opacity)));
}
.steps .step-primary + .step-primary:before,
  .steps .step-primary:after {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-p,oklch(var(--p)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-pc,oklch(var(--pc)/var(--tw-text-opacity)));
}
.steps .step-secondary + .step-secondary:before,
  .steps .step-secondary:after {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-s,oklch(var(--s)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-sc,oklch(var(--sc)/var(--tw-text-opacity)));
}
.steps .step-accent + .step-accent:before,
  .steps .step-accent:after {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-a,oklch(var(--a)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-ac,oklch(var(--ac)/var(--tw-text-opacity)));
}
.steps .step-info + .step-info:before {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-in,oklch(var(--in)/var(--tw-bg-opacity)));
}
.steps .step-info:after {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-in,oklch(var(--in)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-inc,oklch(var(--inc)/var(--tw-text-opacity)));
}
.steps .step-success + .step-success:before {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-su,oklch(var(--su)/var(--tw-bg-opacity)));
}
.steps .step-success:after {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-su,oklch(var(--su)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-suc,oklch(var(--suc)/var(--tw-text-opacity)));
}
.steps .step-warning + .step-warning:before {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-wa,oklch(var(--wa)/var(--tw-bg-opacity)));
}
.steps .step-warning:after {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-wa,oklch(var(--wa)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-wac,oklch(var(--wac)/var(--tw-text-opacity)));
}
.steps .step-error + .step-error:before {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-er,oklch(var(--er)/var(--tw-bg-opacity)));
}
.steps .step-error:after {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-er,oklch(var(--er)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-erc,oklch(var(--erc)/var(--tw-text-opacity)));
}
.tabs-lifted > .tab:focus-visible {
  border-end-end-radius: 0;
  border-end-start-radius: 0;
}
.tab:is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]), .tab:is(input:checked) {
  border-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-border-opacity)));
  --tw-border-opacity: 1;
  --tw-text-opacity: 1;
}
.tab:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.tab:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: -5px;
}
.tab-disabled,
  .tab[disabled] {
  cursor: not-allowed;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
  --tw-text-opacity: 0.2;
}
.tabs-bordered > .tab {
  border-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-border-opacity)));
  --tw-border-opacity: 0.2;
  border-style: solid;
  border-bottom-width: calc(var(--tab-border, 1px) + 1px);
}
.tabs-lifted > .tab {
  border: var(--tab-border, 1px) solid transparent;
  border-width: 0 0 var(--tab-border, 1px) 0;
  border-start-start-radius: var(--tab-radius, 0.5rem);
  border-start-end-radius: var(--tab-radius, 0.5rem);
  border-bottom-color: var(--tab-border-color);
  padding-inline-start: var(--tab-padding, 1rem);
  padding-inline-end: var(--tab-padding, 1rem);
  padding-top: var(--tab-border, 1px);
}
.tabs-lifted > .tab:is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]), .tabs-lifted > .tab:is(input:checked) {
  background-color: var(--tab-bg);
  border-width: var(--tab-border, 1px) var(--tab-border, 1px) 0 var(--tab-border, 1px);
  border-inline-start-color: var(--tab-border-color);
  border-inline-end-color: var(--tab-border-color);
  border-top-color: var(--tab-border-color);
  padding-inline-start: calc(var(--tab-padding, 1rem) - var(--tab-border, 1px));
  padding-inline-end: calc(var(--tab-padding, 1rem) - var(--tab-border, 1px));
  padding-bottom: var(--tab-border, 1px);
  padding-top: 0;
}
.tabs-lifted > .tab:is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]):before, .tabs-lifted > .tab:is(input:checked):before {
  z-index: 1;
  content: "";
  display: block;
  position: absolute;
  width: calc(100% + var(--tab-radius, 0.5rem) * 2);
  height: var(--tab-radius, 0.5rem);
  bottom: 0;
  background-size: var(--tab-radius, 0.5rem);
  background-position: top left,
        top right;
  background-repeat: no-repeat;
  --tab-grad: calc(69% - var(--tab-border, 1px));
  --radius-start: radial-gradient(
        circle at top left,
        transparent var(--tab-grad),
        var(--tab-border-color) calc(var(--tab-grad) + 0.25px),
        var(--tab-border-color) calc(var(--tab-grad) + var(--tab-border, 1px)),
        var(--tab-bg) calc(var(--tab-grad) + var(--tab-border, 1px) + 0.25px)
      );
  --radius-end: radial-gradient(
        circle at top right,
        transparent var(--tab-grad),
        var(--tab-border-color) calc(var(--tab-grad) + 0.25px),
        var(--tab-border-color) calc(var(--tab-grad) + var(--tab-border, 1px)),
        var(--tab-bg) calc(var(--tab-grad) + var(--tab-border, 1px) + 0.25px)
      );
  background-image: var(--radius-start), var(--radius-end);
}
.tabs-lifted > .tab:is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]):first-child:before, .tabs-lifted > .tab:is(input:checked):first-child:before {
  background-image: var(--radius-end);
  background-position: top right;
}
[dir="rtl"] .tabs-lifted > .tab:is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]):first-child:before, [dir="rtl"] .tabs-lifted > .tab:is(input:checked):first-child:before {
  background-image: var(--radius-start);
  background-position: top left;
}
.tabs-lifted > .tab:is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]):last-child:before, .tabs-lifted > .tab:is(input:checked):last-child:before {
  background-image: var(--radius-start);
  background-position: top left;
}
[dir="rtl"] .tabs-lifted > .tab:is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]):last-child:before, [dir="rtl"] .tabs-lifted > .tab:is(input:checked):last-child:before {
  background-image: var(--radius-end);
  background-position: top right;
}
.tabs-lifted
  > :is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled])
  + .tabs-lifted
  :is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]):before, .tabs-lifted > .tab:is(input:checked) + .tabs-lifted .tab:is(input:checked):before {
  background-image: var(--radius-end);
  background-position: top right;
}
.tabs-boxed .tab {
  border-radius: var(--rounded-btn, 0.5rem);
}
.table tr.active,
  .table tr.active:nth-child(even),
  .table-zebra tbody tr:nth-child(even) {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-bg-opacity)));
}
.table-zebra tr.active,
    .table-zebra tr.active:nth-child(even),
    .table-zebra-zebra tbody tr:nth-child(even) {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b3,oklch(var(--b3)/var(--tw-bg-opacity)));
}
.textarea:focus {
  box-shadow: none;
  border-color: var(--fallback-bc,oklch(var(--bc)/0.2));
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: var(--fallback-bc,oklch(var(--bc)/0.2));
}
.textarea-disabled,
  .textarea:disabled,
  .textarea[disabled] {
  cursor: not-allowed;
  --tw-border-opacity: 1;
  border-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-border-opacity)));
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-bg-opacity)));
  color: var(--fallback-bc,oklch(var(--bc)/0.4));
}
.textarea-disabled::placeholder,
  .textarea:disabled::placeholder,
  .textarea[disabled]::placeholder {
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-placeholder-opacity)));
  --tw-placeholder-opacity: 0.2;
}
@keyframes toast-pop {

  0% {
    transform: scale(0.9);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.artboard.phone {
  width: 320px;
}
.artboard.phone-1 {
  width: 320px;
  height: 568px;
}
.artboard.phone-1.horizontal,
      .artboard.phone-1.artboard-horizontal {
  width: 568px;
  height: 320px;
}
.artboard.phone-2 {
  width: 375px;
  height: 667px;
}
.artboard.phone-2.horizontal,
      .artboard.phone-2.artboard-horizontal {
  width: 667px;
  height: 375px;
}
.artboard.phone-3 {
  width: 414px;
  height: 736px;
}
.artboard.phone-3.horizontal,
      .artboard.phone-3.artboard-horizontal {
  width: 736px;
  height: 414px;
}
.artboard.phone-4 {
  width: 375px;
  height: 812px;
}
.artboard.phone-4.horizontal,
      .artboard.phone-4.artboard-horizontal {
  width: 812px;
  height: 375px;
}
.artboard.phone-5 {
  width: 414px;
  height: 896px;
}
.artboard.phone-5.horizontal,
      .artboard.phone-5.artboard-horizontal {
  width: 896px;
  height: 414px;
}
.artboard.phone-6 {
  width: 320px;
  height: 1024px;
}
.artboard.phone-6.horizontal,
      .artboard.phone-6.artboard-horizontal {
  width: 1024px;
  height: 320px;
}
.btm-nav-xs > *:where(.active) {
  border-top-width: 1px;
}
.btm-nav-sm > *:where(.active) {
  border-top-width: 2px;
}
.btm-nav-md > *:where(.active) {
  border-top-width: 2px;
}
.btm-nav-lg > *:where(.active) {
  border-top-width: 4px;
}
.steps-horizontal .step {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  place-items: center;
  text-align: center;
}
.steps-vertical .step {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(1, minmax(0, 1fr));
}
.tabs-md :where(.tab) {
  height: 2rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
  --tab-padding: 1rem;
}
.tabs-lg :where(.tab) {
  height: 3rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  line-height: 2;
  --tab-padding: 1.25rem;
}
.tabs-sm :where(.tab) {
  height: 1.5rem;
  font-size: 0.875rem;
  line-height: .75rem;
  --tab-padding: 0.75rem;
}
.tabs-xs :where(.tab) {
  height: 1.25rem;
  font-size: 0.75rem;
  line-height: .75rem;
  --tab-padding: 0.5rem;
}
.steps-horizontal .step {
  grid-template-rows: 40px 1fr;
  grid-template-columns: auto;
  min-width: 4rem;
}
.steps-horizontal .step:before {
  height: 0.5rem;
  width: 100%;
  --tw-translate-x: 0px;
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  content: "";
  margin-inline-start: -100%;
}
.steps-horizontal .step:where([dir="rtl"], [dir="rtl"] *):before {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.steps-vertical .step {
  gap: 0.5rem;
  grid-template-columns: 40px 1fr;
  grid-template-rows: auto;
  min-height: 4rem;
  justify-items: start;
}
.steps-vertical .step:before {
  height: 100%;
  width: 0.5rem;
  --tw-translate-x: -50%;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  margin-inline-start: 50%;
}
.steps-vertical .step:where([dir="rtl"], [dir="rtl"] *):before {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.collapse {
  visibility: collapse;
}
.relative {
  position: relative;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.col-span-full {
  grid-column: 1 / -1;
}
.m-3 {
  margin: 0.75rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.block {
  display: block;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.h-32 {
  height: 8rem;
}
.h-5 {
  height: 1.25rem;
}
.h-9 {
  height: 2.25rem;
}
.h-full {
  height: 100%;
}
.min-h-full {
  min-height: 100%;
}
.w-2\\/5 {
  width: 40%;
}
.w-4\\/5 {
  width: 80%;
}
.w-5 {
  width: 1.25rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-full {
  width: 100%;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-none {
  flex: none;
}
.shrink {
  flex-shrink: 1;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-pointer {
  cursor: pointer;
}
.list-inside {
  list-style-position: inside;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.text-pretty {
  text-wrap: pretty;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: var(--fallback-p,oklch(var(--p)/var(--tw-bg-opacity, 1)));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-lg\\/8 {
  font-size: 1.125rem;
  line-height: 2rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.italic {
  font-style: italic;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-1 {
  outline-width: 1px;
}
.-outline-offset-1 {
  outline-offset: -1px;
}
.outline-gray-300 {
  outline-color: #d1d5db;
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-blue-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}
.ring-gray-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1));
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

@font-face{font-family:'Red Hat Display';font-style:italic;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIh7wUr0m80wwYf0QCXZzYzUoTg-CSvZX4Vlf1fe6TVmgsD9F-esXnZG0mHlPI&skey=75da5a29d105ef1f&v=v19) format("woff");unicode-range:U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF}
@font-face{font-family:'Red Hat Display';font-style:italic;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIh7wUr0m80wwYf0QCXZzYzUoTg-CSvZX4Vlf1fe6TVmgsD-l-esXnZG0mH&skey=75da5a29d105ef1f&v=v19) format("woff");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}
@font-face{font-family:'Red Hat Display';font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbmyWQkEz_lWZk33BGmGH&skey=3445dd5b86d56e57&v=v19) format("woff");unicode-range:U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF}
@font-face{font-family:'Red Hat Display';font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbmyWQk8z_lWZk33BGg&skey=3445dd5b86d56e57&v=v19) format("woff");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}
@font-face{font-family:'Red Hat Display';font-style:italic;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIh7wUr0m80wwYf0QCXZzYzUoTg-CSvZX4Vlf1fe6TVfQwD9F-esXnZG0mHlPI&skey=75da5a29d105ef1f&v=v19) format("woff");unicode-range:U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF}
@font-face{font-family:'Red Hat Display';font-style:italic;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIh7wUr0m80wwYf0QCXZzYzUoTg-CSvZX4Vlf1fe6TVfQwD-l-esXnZG0mH&skey=75da5a29d105ef1f&v=v19) format("woff");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}
@font-face{font-family:'Red Hat Display';font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbouRQkEz_lWZk33BGmGH&skey=3445dd5b86d56e57&v=v19) format("woff");unicode-range:U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF}
@font-face{font-family:'Red Hat Display';font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbouRQk8z_lWZk33BGg&skey=3445dd5b86d56e57&v=v19) format("woff");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}

/* font-family:'Gilroy', sans-serif; */
html,body{height:100%;margin:0;padding:0}
body{background:#F2F7FF 100%;color:#25396f;font-size:16px;font-family:'Red Hat Display', sans-serif}
main{margin-top:-120px}
#root{height:100%;display:flex;flex-direction:column}

.color-primary{color:#012388}
.app-secondary{color:var(--color-secondary)}
.app-secondary-container{color:var(--color-secondary-container)}
.bg-primary{background:#012388}

/* Header */
.header{padding-bottom:100px}
.top > div{border-bottom:1px solid rgb(108, 142, 194, 0.2)}
.zasmedia{max-width:200px}
.steps .step{color:#fff;font-weight:400 !important;min-width:100px}
.steps .step:before, .steps .step:after {background:rgb(108, 142, 194);color:#012388}
.steps .step-primary + .step-primary:before, .steps .step-primary:after {background:#fff}

/* Structure */
.content{background:#fff;border-radius:12px;padding:48px;min-height:800px}
.content9{min-height:900px}
.content.col{padding:36px}
.max-w-7xl{max-width:90rem}
.dash{width:100%;height:100%;border-radius:12px;border:1px dashed #ccc;stroke:color-mix(in oklab, #ccc 30%, transparent);inset:calc(0.25rem * 0);position:absolute;display: block;}
.dash-over{position:absolute;z-index:1}

.horizontal{display:flex;overflow-x:auto;gap:20px;padding:10px;white-space:nowrap;scrollbar-width:thin;scrollbar-color: gray transparent}
.horizontal .mockup-phone{min-width:348px}
.horizontal::-webkit-scrollbar{height:6px}
.horizontal::-webkit-scrollbar-thumb{background:#ff9920;border-radius:10px}
.horizontal::-webkit-scrollbar-track{background:transparent}

.collapse{border:1px solid #d2d5dc;margin-top:2rem}
.collapse-title{font-weight:700}

.colors-scroll{overflow-x:scroll;max-height:500px;overflow-x:hidden;overflow-y:scroll}
.colors-scroll::-webkit-scrollbar{width:8px}
.colors-scroll::-webkit-scrollbar-track{background:transparent}
.colors-scroll::-webkit-scrollbar-thumb{background-color:#ff9920;border-radius:4px}

/* ==================== */
/*  Mobile
/* ==================== */
.mockup-crop{max-height:250px;overflow:hidden}
.mockup-crop.bar{max-height:150px}
.mockup-phone{font-family:'Gilroy', sans-serif;text-wrap: wrap;}
.mockup-phone .camera::before, .mockup-phone .camera::after{display:none}

.artboard{color:var(--color-text)}
.artboard.phone-1, .mockup-phone .display{height:650px}
.artboard.phone-7{width:450px;height:900px}
.artboard.apps{display:grid;gap:10px;grid-template-columns:repeat(4, 1fr);justify-content:center;align-content:start;text-align:center;padding:40px 15px 0}
.artboard.apps span{color:#fff;font-size:13px;line-height:13px;text-shadow:1px 1px 1px rgba(0, 0, 0, .5);display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;max-height:3em;}
.artboard .icon{max-width:86px;display:flex;flex-direction:column;align-items:center;justify-content:start}
.artboard .icon img, .artboard .bg-icon{width:50px;border-radius:12px;margin-bottom:5px}
.artboard .bg-icon img{margin:0}

.submit-icon .app-icon{max-width:92px;border-radius:12px;border:1px solid #ccc}
.store{width:320px;min-height:300px;padding:40px 20px 20px}
.store .icon{margin-right:20px}
.store .app-icon{width:60px;border-radius:12px;border:1px solid #ccc;flex-grow:1}
.store .app-store-title{font-size:1.25rem;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;line-clamp:2;-webkit-box-orient:vertical}
.app-store .app-icon{width:90px}
.app-store .icon{margin-right:10px}
.app-gradient{background:url(${___CSS_LOADER_URL_REPLACEMENT_1___});background-size:100% 100%}

.app-bg{background:radial-gradient(circle at 50% 40%, var(--color-background-center) 0%, var(--color-background) 100%)}
.app-intro{height:65%}
.app-intro img, .app-radio .logo img{max-width:70%;max-height:60%;height:auto;width:auto;object-fit:contain}
.app-radio .logo img{max-height:90%}
.app-more{background:color-mix(in oklab, #000 20%, var(--color-primary));}

.topbar{background:var(--color-primary-dark);color:var(--color-system);border-radius:38px 38px 0 0;display:flex;justify-content:space-between;padding:10px 30px}
.topbar i + i{padding-left:10px}

.appbar{background:var(--color-primary);padding:8px 10px;box-shadow:0 2px 2px rgba(0,0,0,0.1);display:flex;justify-content:space-between;align-items:center}
.appbar i{font-size:24px;color:var(--color-on-primary)}
.appbar i + i{padding-left:15px}
.appbar-logo{max-height:40px}

.icon-box{display:flex;padding:12px 0;flex-direction:column;align-items:center;font-weight:700;font-size:16px;color:var(--color-on-surface)}
.icon-box i{font-size:32px;margin-bottom:10px}

.navbar{background:var(--color-tab);display:flex;justify-content:space-between;color:var(--color-on-tab);border-radius:0 0 38px 38px;min-height:3rem;padding:8px 20px}
.navbar .icon-box.active{color:var(--color-tab-primary)}
.navbar .icon-box{padding:10px 0 10px;color:var(--color-on-tab)}
.navbar .icon-box i{font-size:22px}
.navbar .icon-box.svg{padding-top:4px}
.navbar .icon-box.svg svg{margin-bottom:4px;width:34px;height:34px}
.navbar .spacer{width:auto;height:77px}
.navbar .canvas-field{max-width:25%;text-align:center}
.navbar .shrink{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%}

.app-mini .topbar{font-size:12px}
.app-mini .appbar-logo{max-height:30px}

.app-mini .appbar i{font-size:18px}
.app-mini .navbar{padding:2px 20px 8px;line-height:8px}
.app-mini .navbar .icon-box i{font-size:18px}
.app-mini .navbar .icon-box.svg{padding-top:2px}
.app-mini .icon-box{font-size:12px;padding:8px 0 6px}
.app-mini .icon-box.svg svg{margin-bottom:4px}

/* Home */
.app-home{max-height:504px;padding:15px 10px 10px;overflow:hidden}

/* Elements */
.artboard .el, .canvas-fields .el, .spacer{background:color-mix(in srgb, var(--color-surface) 60%, transparent);color:var(--color-on-surface);box-shadow:4px 4px 4px rgba(0,0,0,0.1);border-radius:6px;position:relative}
.space{color:transparent !important}
.spacer.full{grid-column:span 3}
.canvas-fields .shrink{font-size:14px}

.app-home > .el + .el{margin-top:10px}
.dash-tv{display:flex;align-items:center}
.dash-tv img{width:45%;border-radius:6px}
.dash-tv > div{flex:1 1;min-width:0;padding:0 15px}
.dash-tv strong{font-size:20px;line-height:20px;display:block;font-weight:700;color:var(--color-secondary);margin-bottom:5px}
.dash-tv div span{font-size:16px;line-height:18px;display:inline-block;}

.wrap{display:block;word-wrap:break-word;overflow-wrap:break-word;white-space:normal}

.hList{width:435px;overflow:hidden}
.hList .topEl{display:flex;justify-content:space-between;margin-bottom:15px;align-items:center;margin-right:15px}
.hList .topEl span{font-weight:700;color:var(--color-hint)}
.hList .topEl button{background:var(--color-hint);;border:none;color:var(--color-background);padding:6px 8px;font-size:12px;border-radius:6px}
.hList ul{width:600px;margin:0;padding:0;display:flex;flex-wrap:nowrap;overflow-x:auto;overflow-y:hidden}
.hList ul li{width:28%;margin-right:15px;list-style:none}
.hList ul li img{width:100%}
.hList ul li span{display:-webkit-box;-webkit-line-clamp:2;line-clamp:2;-webkit-box-orient:vertical;font-size:16px;font-weight:700;margin-top:10px;color:var(--color-highlight)}

.app-mini .hList{width:315px;margin-top:10px}
.app-mini .hList .topEl{margin-bottom:10px}
.app-mini .hList .topEl button{font-size:10px;padding:4px 6px}
.app-mini .hList ul li span{font-size:13px;margin-top:8px}
.app-mini .app-home .icon-box{font-size:12px;padding:12px 0 10px}
.app-mini .app-home .icon-box i{font-size:24px;margin-bottom:4px}
.app-mini .dash-tv strong{font-size:16px}
.app-mini .dash-tv div span{font-size:13px}

.tabs, .app-more .el{background:transparent;box-shadow:none}
.tabs input{color:var(--color-primary-light);position:relative;;z-index:1;padding:5px 16px;height:38px;font-weight:700}
.tabs input:first-child::before{background:var(--color-primary);width:400px;height:35px;content:"";position:absolute;top:0;left:0;z-index:-1}
.tabs-border .tab{border-bottom:3px solid var(--color-primary)}
.tabs-border .tab:is(input:checked){color:var(--color-on-primary);border-color:var(--color-primary-container)}
.tab-content{max-width:320px}
.app-tv .tab-content{max-height:287px;overflow:hidden}

.share{font-size:14px;border:1px solid rgba(255,255,255,0.2);padding:8px 10px;border-radius:6px;color:var(--color-secondary-container)}
.share li{width:20px;height:20px;border-radius:50%;margin-left:5px;padding:0 0 1px 3px}
.share li i{font-size:12px;color:#fff}
.share .icon-wa{background:#3EC351;padding:0 0 1px 5px}
.share .icon-fb{background:#4166B1}
.share .icon-sh{background:#006E62}
.share .icon-x{background:#000}
.share .icon-ma{background:#006ab1}

.programs .el img{width:35%;border-radius:6px;margin-right:10px}
.programs .info{font-size:10px;color:var(--color-secondary-container)}

.switch{position:relative;display:inline-block;width:30px;height:17px;margin-left:10px}
.switch input{opacity:0;width:0;height:0}
.switch .slider{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;border:1px solid var(--color-divider);transition:.4s;border-radius:34px}
.switch .slider:before{position:absolute;content:"";height:13px;width:13px;left:2px;bottom:1px;background-color:var(--color-secondary-container);transition:.4s;border-radius:50%}
.switch input:checked + .slider{background-color:var(--color-primary)}
.switch input:checked + .slider:before{transform:translateX(13px)}

.dev-date{width:12%;color:var(--color-hint);margin-right:10px}
.dev-verse{color:var(--color-secondary-container);max-width:230px;font-size:11px;border-radius:6px;padding:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.dev-chapter{text-align:right;font-size:11px;color:var(--color-secondary-container)}

.button{background:var(--color-secondary);color: var(--color-on-secondary);border-radius:6px;}
.shimmer{background:var(--color-shimmer);height:80px;width:80px;border-radius:6px;animation: shimmer 3s;animation-iteration-count:infinite;background:linear-gradient(to right, var(--color-shimmer) 5%, color-mix(in srgb, var(--color-shimmer) 50%, white) 25%, var(--color-shimmer) 35%);background-size:1000px 100%}

/* Menu */
.app-menu{background:var(--color-primary);color:var(--color-on-primary)}
.app-menu .login{background:color-mix(in srgb, var(--color-primary) 90%, var(--color-primary-light));color:var(--color-primary-light)}
.app-menu .login .circle{background:var(--color-primary);padding:8px 13px;display:inline-block; border-radius:50%;color:var(--color-on-primary)}
.app-menu li{display:flex;justify-content:space-between;padding:15px 15px;align-items: center;}
.app-menu li i{color:var(--color-primary-light)}
.app-menu li div{flex-grow:1;margin:0 20px}
.app-menu .border-top{border-top:1px solid var(--color-canvas)}

/* News */
.app-news{max-height:504px;overflow:hidden}
.app-news .el{border-radius:0;}
.app-news .el img{border-radius:6px}
.app-news .info{font-size:12px;color:var(--color-secondary-container)}
.app-news .horiz img{width:30%;object-fit:cover}

/* Radio */
.app-radio .logo{height:40%}
.playing-now{background:var(--color-bg);color:var(--color-on-bg);padding:5px 20px;border-radius:20px;font-size:12px}

.radio-controls{background:var(--color-tab);color:var(--color-on-tab);width:400px;height:200px;font-size:24px;border-radius:50% 50% 0 0;margin-left:-40px;margin-bottom:-50px}
.radio-controls .controls{width:220px;margin:0 auto;padding-top:35px}
.radio-controls .play{background:var(--color-tab-primary);padding:25px 29px 22px 33px;border-radius:50%;box-shadow:0 5px 10px rgba(0,0,0,.1)}
.radio-controls .play i{font-size:2.5rem;color:var(--color-tab)}

.app-more .canvas-fields{padding:15px 0 0;gap:0}
.app-more .canvas-field{padding:5px 0}
.app-more .el{flex-direction:row}
.app-more .icon-box i{width:40px;margin:0 30px 0 30px;text-align:center;color:var(--color-primary-light);}
.app-more .icon-box{font-size:20px;color:var(--color-on-primary);}
.app-more .spacer{height:50px}
.app-more .canvas-field + .canvas-field{border-top:2px solid rgba(0,0,0, .2)}

/* .app{background:red;width:1100px;margin:0 auto} */
.sidebar-wrap{height:900px;font-weight:700;color:#172b4c;display:flex;flex-direction:column;align-items:center;border-radius:10px}
.sidebar{width:300px;overflow-x:scroll;max-height:840px;overflow-x:hidden;overflow-y:scroll}
.sidebar::-webkit-scrollbar{width:8px}
.sidebar::-webkit-scrollbar-track{background:transparent}
.sidebar::-webkit-scrollbar-thumb{background-color:#ff9920;border-radius:4px}

.sidebar-field{all:unset;display:flex;align-items:center;height:50px;width:250px;border-bottom:1px solid #e0e4f4;-webkit-user-select:none;user-select:none;padding:5px}
.sidebar-field-drag-handle{background:#ff9920;min-width:42px;border-radius:6px;cursor:grab;color:#fff;font-size:20px;padding:10px 10px 4px;margin-right:10px;text-align:center}
.sidebar-field.overlay{background:white;color:white}
.disabled .sidebar-field-drag-handle{background:#ccc;cursor:auto}

.device{position:relative;margin:40px auto;width:450px;height:900px;border-radius:40px;color:var(--color-system);box-shadow:0 0 0 11px #1f1f1f,0 0 0 13px #191919,0 0 0 20px #111;background:radial-gradient(circle at 50% 40%, var(--color-background-light) 0%, var(--color-background) 100%)}
.device:before,.device:after{content:"";position:absolute;left:50%;transform:translateX(-50%)}
.device:before{top:0;width:56%;height:30px;background-color:#1f1f1f;border-radius:0 0 40px 40px}
.device s,.device b,.device s{position:absolute;display:block;color:transparent}
.device s{top:0;left:50%;transform:translate(-50%,6px);height:8px;width:15%;background-color:#101010;border-radius:8px;box-shadow:inset 0 -3px 3px 0 rgba(255,255,255,.2)}
.device b{left:10%;top:0;transform:translate(180px,4px);width:12px;height:12px;background-color:#101010;border-radius:12px;box-shadow:inset 0 -3px 2px 0 rgba(255,255,255,.2)}
.device b:after{content:"";position:absolute;background-color:#2d4d76;width:6px;height:6px;top:3px;left:3px;display:block;border-radius:4px;box-shadow:inset 0 -2px 2px rgba(0,0,0,.5)}

.canvas-bg{background:var(--color-canvas)}
.canvas{flex:1 1;border-radius:5px;padding:10px;display:flex;flex-direction:column;max-height:100%;overflow-y:auto}
.canvas-fields{display:grid;gap:15px;grid-template-columns:repeat(3, 1fr);padding:15px;position:absolute;top:0;left:0;right:-15px;padding-bottom:20px;overflow-x:hidden;overflow-y:scroll;max-height:710px}
.canvas-field.overlay{opacity:.5}
.canvas-fields.flex{display:flex;flex-direction:column}
.canvas-field > *{width:100%;pointer-events:none}
.screen{position:relative;height:710px}
.screen-opacity .screen{opacity:0.2;}
.spacer{background:white;width:100%;opacity:.25;height:100px}
.canvas-fields::-webkit-scrollbar{width:8px}
.canvas-fields::-webkit-scrollbar-track{background:transparent}
.canvas-fields::-webkit-scrollbar-thumb{background-color:#e7b40d;border-radius:4px}

.image, .slider, .tv_full, .news_full, .videos, .youtube_videos_full, .donate_full, .next_events{grid-column:span 3}

.outline-1{border:1px solid #e8e8e8}

.carousel{width:100%;overflow:hidden;position:relative}
.carousel-track{display:flex;width:300%;animation:slide 9s infinite}
.carousel-track img{width:100%;flex:1 0 100%}

@keyframes shimmer{from{background-position: -1000px 0}to{background-position:1000px 0}}
@keyframes slide {
    0%,33%{transform:translateX(0%)}
    34%,66%{transform:translateX(-100%)}
    67%,100%{transform:translateX(-200%)}
}
.placeholder\\:text-gray-400::placeholder {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.focus\\:outline-1:focus {
  outline-width: 1px;
}
.focus\\:-outline-offset-1:focus {
  outline-offset: -1px;
}
@media (min-width: 640px) {

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-sm\\/6 {
    font-size: 0.875rem;
    line-height: 1.5rem;
  }
}
@media (min-width: 1024px) {

  .lg\\:text-balance {
    text-wrap: balance;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:text-center {
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;;EAAA,uDAAc;EAAd;AAAc;;AAAd;;EAAA;IAAA,mBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,sBAAc;IAAd;EAAc;;EAAd;;IAAA;MAAA,kBAAc;MAAd,qBAAc;MAAd,sBAAc;MAAd,qBAAc;MAAd,sBAAc;MAAd,qBAAc;MAAd,sBAAc;MAAd,qBAAc;MAAd,sBAAc;MAAd,sBAAc;MAAd,sBAAc;MAAd,sBAAc;MAAd,sBAAc;MAAd,sBAAc;MAAd,uBAAc;MAAd,sBAAc;MAAd,uBAAc;MAAd,sBAAc;MAAd,uBAAc;MAAd,sBAAc;MAAd;IAAc;EAAA;AAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,mBAAc;EAAd,wBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,4BAAc;EAAd,2BAAc;EAAd,aAAc;EAAd,aAAc;EAAd,aAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,uBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,iBAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd,yBAAc;EAAd,wBAAc;EAAd,0BAAc;EAAd,wBAAc;EAAd,gCAAc;EAAd,kCAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,iCAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,aAAoB;EAApB,WAAoB;EAApB,mBAAoB;EAApB,yBAAoB;EAApB,mBAAoB;EAApB,qBAAoB;EAApB,SAAoB;EAApB,kBAAoB;EAApB,uCAAoB;EAApB,iBAAoB;EAApB,sBAAoB;EAApB,0EAAoB;EAApB,aAAoB;EAApB,oBAAoB;EAApB,iEAAoB;EAApB,iDAAoB;EAApB,qDAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,sBAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA,oBAAoB;IAApB;EAAoB;;EAApB;;;IAAA,kBAAoB;IAApB,wEAAoB;IAApB,oBAAoB;IAApB;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,6BAAoB;EAApB,uBAAoB;EAApB,wBAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,8CAAoB;EAApB,8CAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,yCAAoB;EAApB,iBAAoB;EAApB,0EAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,aAAoB;EAApB,gBAAoB;EAApB,mCAAoB;EAApB,mCAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;;;;EAAA,oBAAoB;EAApB;AAAoB;AAApB;;EAAA,gBAAoB;EAApB;AAAoB;AAApB;;EAAA,YAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB,eAAoB;EAApB,2BAAoB;EAApB;kCAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;EAAA;AAAoB;AAApB;;EAAA;AAAoB;AAApB;;;;;EAAA,mBAAoB;EAApB;AAAoB;AAApB;;EAAA;;IAAA,oBAAoB;IAApB,sBAAoB;IAApB,wEAAoB;IAApB,oBAAoB;IAApB,iEAAoB;IAApB;EAAoB;;EAApB;IAAA,eAAoB;IAApB,8BAAoB;IAApB;EAAoB;;EAApB;;IAAA;MAAA;IAAoB;EAAA;;EAApB;;IAAA,mBAAoB;IAApB,iEAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,aAAoB;EAApB,yBAAoB;UAApB,iBAAoB;EAApB,mBAAoB;EAApB,8BAAoB;EAApB,qBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,gBAAoB;EAApB,YAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,eAAoB;EAApB,cAAoB;EAApB,mBAAoB;EAApB,yCAAoB;EAApB,iBAAoB;EAApB,yBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;;EAAA,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,sBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,yBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,sBAAoB;EAApB,yBAAoB;EAApB,mBAAoB;EAApB,WAAoB;EAApB,6DAAoB;EAApB,yBAAoB;UAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,yBAAoB;UAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,aAAoB;EAApB,cAAoB;EAApB,sBAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB,sCAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,kBAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,0EAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,sBAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,gDAAoB;EAApB,2BAAoB;EAApB,6CAAoB;EAApB,4BAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;;;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB,YAAoB;EAApB,eAAoB;EAApB,yBAAoB;UAApB,iBAAoB;EAApB,gBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,uBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,kDAAoB;EAApB,+CAAoB;EAApB,yDAAoB;EAApB,uBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,0BAAoB;EAApB,iBAAoB;EAApB,wCAAoB;EAApB,aAAoB;EAApB,yBAAoB;EAApB;AAAoB;AAApB;;EAAA;AAAoB;AAApB;;EAAA;AAAoB;AAApB;EAAA,gBAAoB;EAApB,cAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,yCAAoB;EAApB,iBAAoB;EAApB,yBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,qDAAoB;EAApB,oBAAoB;EAApB,mEAAoB;EAApB,iDAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;;EAAA,oBAAoB;EAApB,sBAAoB;EAApB,wEAAoB;EAApB,oBAAoB;EAApB,iEAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,mBAAoB;EAApB,yBAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB;AAAoB;AAApB;;EAAA,4BAAoB;EAApB,0DAAoB;EAApB,8BAAoB;EAApB;;;;;;;;;;;AAAoB;AAApB;EAAA,kBAAoB;EAApB,0EAAoB;EAApB,4BAAoB;EAApB,0DAAoB;EAApB;;;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,cAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,cAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,uBAAoB;EAApB,kBAAoB;EAApB,+LAAoB;EAApB,wBAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB,0BAAoB;EAApB,yBAAoB;EAApB,WAAoB;EAApB,wBAAoB;EAApB,WAAoB;EAApB,yBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,cAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,wBAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB,0BAAoB;EAApB,WAAoB;EAApB,wBAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;;;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,aAAoB;EAApB,wBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;;;EAAA,oBAAoB;EAApB;;AAAoB;AAApB;;;;;EAAA,sBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;;;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,wEAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,gBAAoB;EAApB,qDAAoB;EAApB,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;;EAAA,mBAAoB;EAApB,sBAAoB;EAApB,0EAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB;AAAoB;AAApB;;;;EAAA,wEAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,qBAAoB;EAApB,mBAAoB;EAApB,aAAoB;EAApB,8BAAoB;EAApB,eAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,0EAAoB;EAApB,YAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,eAAoB;EAApB,uBAAoB;EAApB,YAAoB;EAApB,UAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;;EAAA,yCAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,iBAAoB;EAApB,wJAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB,iEAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;;;EAAA,kBAAoB;EAApB,wEAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,iBAAoB;EAApB,cAAoB;EAApB,mBAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,wBAAoB;EAApB,0CAAoB;EAApB,yBAAoB;EAApB,wDAAoB;EAApB,WAAoB;EAApB,yBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA,yBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,aAAoB;EAApB,cAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,QAAoB;EAApB,SAAoB;EAApB,gBAAoB;EAApB,YAAoB;EAApB,YAAoB;EAApB,cAAoB;EAApB,+BAAoB;EAApB,gCAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,QAAoB;EAApB,SAAoB;EAApB,WAAoB;EAApB,WAAoB;EAApB,kBAAoB;EAApB,yBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,QAAoB;EAApB,SAAoB;EAApB,UAAoB;EAApB,WAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,iBAAoB;EAApB,kBAAoB;EAApB,cAAoB;EAApB,eAAoB;EAApB,YAAoB;EAApB,gBAAoB;EAApB,uBAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,YAAoB;EAApB,QAAoB;EAApB,mBAAoB;EAApB,eAAoB;EAApB,sBAAoB;EAApB,+LAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,aAAoB;EAApB,QAAoB;EAApB,cAAoB;EAApB,qBAAoB;EAApB,mBAAoB;EAApB,+LAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA,kBAAoB;EAApB,0EAAoB;EAApB,sBAAoB;EAApB,0DAAoB;EAApB;;AAAoB;AAApB;EAAA,mBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;;EAAoB;;EAApB;IAAA;;EAAoB;;EAApB;IAAA;;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA,QAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB,cAAoB;EAApB,WAAoB;EAApB,+LAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB,iEAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,UAAoB;EAApB,kBAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB,aAAoB;EAApB,YAAoB;EAApB,WAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,kBAAoB;EAApB,wEAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;;EAAA,kBAAoB;EAApB,wEAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;;EAAA,kBAAoB;EAApB,wEAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;;EAAA,kBAAoB;EAApB,wEAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB;AAAoB;AAApB;EAAA,0EAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;;EAAA,mBAAoB;EAApB,iEAAoB;EAApB;AAAoB;AAApB;EAAA,0EAAoB;EAApB,wBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,gDAAoB;EAApB,0CAAoB;EAApB,oDAAoB;EAApB,kDAAoB;EAApB,4CAAoB;EAApB,8CAAoB;EAApB,4CAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,oFAAoB;EAApB,kDAAoB;EAApB,gDAAoB;EAApB,yCAAoB;EAApB,6EAAoB;EAApB,2EAAoB;EAApB,sCAAoB;EAApB;AAAoB;AAApB;EAAA,UAAoB;EAApB,WAAoB;EAApB,cAAoB;EAApB,kBAAoB;EAApB,iDAAoB;EAApB,iCAAoB;EAApB,SAAoB;EAApB,0CAAoB;EAApB;iBAAoB;EAApB,4BAAoB;EAApB,8CAAoB;EAApB;;;;;;OAAoB;EAApB;;;;;;OAAoB;EAApB;AAAoB;AAApB;EAAA,mCAAoB;EAApB;AAAoB;AAApB;EAAA,qCAAoB;EAApB;AAAoB;AAApB;EAAA,qCAAoB;EAApB;AAAoB;AAApB;EAAA,mCAAoB;EAApB;AAAoB;AAApB;;;;EAAA,mCAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,kBAAoB;EAApB;AAAoB;AAApB;;;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,qDAAoB;EAApB,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;EAAA,mBAAoB;EAApB,sBAAoB;EAApB,0EAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB;AAAoB;AAApB;;;EAAA,wEAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,qBAAoB;IAApB;EAAoB;;EAApB;IAAA,mBAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB,gDAAoB;EAApB,6CAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,gDAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,4BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,WAAoB;EAApB,qBAAoB;EAApB,qBAAoB;EAApB,+LAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,+BAAoB;EAApB,wBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,aAAoB;EAApB,sBAAoB;EAApB,sBAAoB;EAApB,+LAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB;AAAoB;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAGnB,WAAW,6BAA6B,CAAC,iBAAiB,CAAC,eAAe,CAAC,iBAAiB,CAAC,wJAAwJ,CAAC,oIAAoI;AAC1X,WAAW,6BAA6B,CAAC,iBAAiB,CAAC,eAAe,CAAC,iBAAiB,CAAC,qJAAqJ,CAAC,6KAA6K;AACha,WAAW,6BAA6B,CAAC,iBAAiB,CAAC,eAAe,CAAC,iBAAiB,CAAC,qJAAqJ,CAAC,oIAAoI;AACvX,WAAW,6BAA6B,CAAC,iBAAiB,CAAC,eAAe,CAAC,iBAAiB,CAAC,mJAAmJ,CAAC,6KAA6K;AAC9Z,WAAW,6BAA6B,CAAC,iBAAiB,CAAC,eAAe,CAAC,iBAAiB,CAAC,wJAAwJ,CAAC,oIAAoI;AAC1X,WAAW,6BAA6B,CAAC,iBAAiB,CAAC,eAAe,CAAC,iBAAiB,CAAC,qJAAqJ,CAAC,6KAA6K;AACha,WAAW,6BAA6B,CAAC,iBAAiB,CAAC,eAAe,CAAC,iBAAiB,CAAC,qJAAqJ,CAAC,oIAAoI;AACvX,WAAW,6BAA6B,CAAC,iBAAiB,CAAC,eAAe,CAAC,iBAAiB,CAAC,mJAAmJ,CAAC,6KAA6K;;AAE9Z,sCAAsC;AACtC,UAAU,WAAW,CAAC,QAAQ,CAAC,SAAS;AACxC,KAAK,uBAAuB,CAAC,aAAa,CAAC,cAAc,CAAC,yCAAyC;AACnG,KAAK,iBAAiB;AACtB,MAAM,WAAW,CAAC,YAAY,CAAC,qBAAqB;;AAEpD,eAAe,aAAa;AAC5B,eAAe,4BAA4B;AAC3C,yBAAyB,sCAAsC;AAC/D,YAAY,kBAAkB;;AAE9B,WAAW;AACX,QAAQ,oBAAoB;AAC5B,WAAW,+CAA+C;AAC1D,UAAU,eAAe;AACzB,aAAa,UAAU,CAAC,0BAA0B,CAAC,eAAe;AAClE,yCAAyC,6BAA6B,CAAC,aAAa;AACpF,yEAAyE,eAAe;;AAExF,cAAc;AACd,SAAS,eAAe,CAAC,kBAAkB,CAAC,YAAY,CAAC,gBAAgB;AACzE,UAAU,gBAAgB;AAC1B,aAAa,YAAY;AACzB,WAAW,eAAe;AAC1B,MAAM,UAAU,CAAC,WAAW,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,iDAAiD,CAAC,uBAAuB,CAAC,iBAAiB,CAAC,cAAc,CAAC;AAClL,WAAW,iBAAiB,CAAC,SAAS;;AAEtC,YAAY,YAAY,CAAC,eAAe,CAAC,QAAQ,CAAC,YAAY,CAAC,kBAAkB,CAAC,oBAAoB,CAAC,iCAAiC;AACxI,0BAA0B,eAAe;AACzC,+BAA+B,UAAU;AACzC,qCAAqC,kBAAkB,CAAC,kBAAkB;AAC1E,qCAAqC,sBAAsB;;AAE3D,UAAU,wBAAwB,CAAC,eAAe;AAClD,gBAAgB,eAAe;;AAE/B,eAAe,iBAAiB,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,iBAAiB;AACrF,kCAAkC,SAAS;AAC3C,wCAAwC,sBAAsB;AAC9D,wCAAwC,wBAAwB,CAAC,iBAAiB;;AAElF,yBAAyB;AACzB;yBACyB;AACzB,aAAa,gBAAgB,CAAC,eAAe;AAC7C,iBAAiB,gBAAgB;AACjC,cAAc,gCAAgC,CAAC,eAAe,CAAC;AAC/D,4DAA4D,YAAY;;AAExE,UAAU,uBAAuB;AACjC,0CAA0C,YAAY;AACtD,kBAAkB,WAAW,CAAC,YAAY;AAC1C,eAAe,YAAY,CAAC,QAAQ,CAAC,oCAAoC,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,iBAAiB,CAAC,mBAAmB;AAC1J,oBAAoB,UAAU,CAAC,cAAc,CAAC,gBAAgB,CAAC,yCAAyC,CAAC,mBAAmB,CAAC,oBAAoB,CAAC,2BAA2B,CAAC,eAAe,CAAC,sBAAsB,CAAC,cAAc,CAAC;AACpO,gBAAgB,cAAc,CAAC,YAAY,CAAC,qBAAqB,CAAC,kBAAkB,CAAC,qBAAqB;AAC1G,wCAAwC,UAAU,CAAC,kBAAkB,CAAC,iBAAiB;AACvF,uBAAuB,QAAQ;;AAE/B,uBAAuB,cAAc,CAAC,kBAAkB,CAAC,qBAAqB;AAC9E,OAAO,WAAW,CAAC,gBAAgB,CAAC,sBAAsB;AAC1D,aAAa,iBAAiB;AAC9B,iBAAiB,UAAU,CAAC,kBAAkB,CAAC,qBAAqB,CAAC,WAAW;AAChF,wBAAwB,iBAAiB,CAAC,eAAe,CAAC,mBAAmB,CAAC,oBAAoB,CAAC,YAAY,CAAC,2BAA2B;AAC3I,qBAAqB,UAAU;AAC/B,iBAAiB,iBAAiB;AAClC,cAAc,kDAAmC,CAAC,yBAAyB;;AAE3E,QAAQ,8GAA8G;AACtH,WAAW,UAAU;AACrB,qCAAqC,aAAa,CAAC,cAAc,CAAC,WAAW,CAAC,UAAU,CAAC,kBAAkB;AAC3G,qBAAqB,cAAc;AACnC,UAAU,8DAA8D,CAAC;;AAEzE,QAAQ,oCAAoC,CAAC,yBAAyB,CAAC,2BAA2B,CAAC,YAAY,CAAC,6BAA6B,CAAC,iBAAiB;AAC/J,cAAc,iBAAiB;;AAE/B,QAAQ,+BAA+B,CAAC,gBAAgB,CAAC,oCAAoC,CAAC,YAAY,CAAC,6BAA6B,CAAC,kBAAkB;AAC3J,UAAU,cAAc,CAAC,6BAA6B;AACtD,cAAc,iBAAiB;AAC/B,aAAa,eAAe;;AAE5B,UAAU,YAAY,CAAC,cAAc,CAAC,qBAAqB,CAAC,kBAAkB,CAAC,eAAe,CAAC,cAAc,CAAC,6BAA6B;AAC3I,YAAY,cAAc,CAAC,kBAAkB;;AAE7C,QAAQ,2BAA2B,CAAC,YAAY,CAAC,6BAA6B,CAAC,yBAAyB,CAAC,2BAA2B,CAAC,eAAe,CAAC,gBAAgB;AACrK,yBAAyB,8BAA8B;AACvD,kBAAkB,mBAAmB,CAAC,yBAAyB;AAC/D,oBAAoB,cAAc;AAClC,sBAAsB,eAAe;AACrC,0BAA0B,iBAAiB,CAAC,UAAU,CAAC,WAAW;AAClE,gBAAgB,UAAU,CAAC,WAAW;AACtC,sBAAsB,aAAa,CAAC,iBAAiB;AACrD,gBAAgB,aAAa,CAAC,kBAAkB,CAAC,eAAe,CAAC,sBAAsB,CAAC,cAAc;;AAEtG,kBAAkB,cAAc;AAChC,uBAAuB,eAAe;;AAEtC,oBAAoB,cAAc;AAClC,kBAAkB,oBAAoB,CAAC,eAAe;AACtD,8BAA8B,cAAc;AAC5C,gCAAgC,eAAe;AAC/C,oBAAoB,cAAc,CAAC,iBAAiB;AACpD,4BAA4B,iBAAiB;;AAE7C,SAAS;AACT,UAAU,gBAAgB,CAAC,sBAAsB,CAAC,eAAe;;AAEjE,aAAa;AACb,2CAA2C,oEAAoE,CAAC,6BAA6B,CAAC,sCAAsC,CAAC,iBAAiB,CAAC,iBAAiB;AACxN,OAAO,4BAA4B;AACnC,aAAa,kBAAkB;AAC/B,uBAAuB,cAAc;;AAErC,sBAAsB,eAAe;AACrC,SAAS,YAAY,CAAC,kBAAkB;AACxC,aAAa,SAAS,CAAC,iBAAiB;AACxC,eAAe,QAAM,CAAC,WAAW,CAAC,cAAc;AAChD,gBAAgB,cAAc,CAAC,gBAAgB,CAAC,aAAa,CAAC,eAAe,CAAC,4BAA4B,CAAC,iBAAiB;AAC5H,kBAAkB,cAAc,CAAC,gBAAgB,CAAC,oBAAoB,CAAC;;AAEvE,MAAM,aAAa,CAAC,oBAAoB,CAAC,wBAAwB,CAAC,kBAAkB;;AAEpF,OAAO,WAAW,CAAC,eAAe;AAClC,cAAc,YAAY,CAAC,6BAA6B,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,iBAAiB;AAChH,mBAAmB,eAAe,CAAC,uBAAuB;AAC1D,qBAAqB,4BAA4B,EAAE,WAAW,CAAC,6BAA6B,CAAC,eAAe,CAAC,cAAc,CAAC,iBAAiB;AAC7I,UAAU,WAAW,CAAC,QAAQ,CAAC,SAAS,CAAC,YAAY,CAAC,gBAAgB,CAAC,eAAe,CAAC,iBAAiB;AACxG,aAAa,SAAS,CAAC,iBAAiB,CAAC,eAAe;AACxD,iBAAiB,UAAU;AAC3B,kBAAkB,mBAAmB,CAAC,oBAAoB,CAAC,YAAY,CAAC,2BAA2B,CAAC,cAAc,CAAC,eAAe,CAAC,eAAe,CAAC,4BAA4B;;AAE/K,iBAAiB,WAAW,CAAC,eAAe;AAC5C,wBAAwB,kBAAkB;AAC1C,+BAA+B,cAAc,CAAC,eAAe;AAC7D,4BAA4B,cAAc,CAAC,cAAc;AACzD,8BAA8B,cAAc,CAAC,mBAAmB;AAChE,gCAAgC,cAAc,CAAC,iBAAiB;AAChE,0BAA0B,cAAc;AACxC,4BAA4B,cAAc;;AAE1C,qBAAqB,sBAAsB,CAAC,eAAe;AAC3D,YAAY,gCAAgC,CAAC,iBAAiB,EAAE,SAAS,CAAC,gBAAgB,CAAC,WAAW,CAAC,eAAe;AACtH,gCAAgC,+BAA+B,CAAC,WAAW,CAAC,WAAW,CAAC,UAAU,CAAC,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,UAAU;AAC5I,kBAAkB,4CAA4C;AAC9D,oCAAoC,6BAA6B,CAAC,2CAA2C;AAC7G,aAAa,eAAe;AAC5B,qBAAqB,gBAAgB,CAAC,eAAe;;AAErD,OAAO,cAAc,CAAC,sCAAsC,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,sCAAsC;AACtI,UAAU,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,eAAe,CAAC,mBAAmB;AACtF,YAAY,cAAc,CAAC,UAAU;AACrC,gBAAgB,kBAAkB,CAAC,mBAAmB;AACtD,gBAAgB,kBAAkB;AAClC,gBAAgB,kBAAkB;AAClC,eAAe,eAAe;AAC9B,gBAAgB,kBAAkB;;AAElC,kBAAkB,SAAS,CAAC,iBAAiB,CAAC,iBAAiB;AAC/D,gBAAgB,cAAc,CAAC,sCAAsC;;AAErE,QAAQ,iBAAiB,CAAC,oBAAoB,CAAC,UAAU,CAAC,WAAW,CAAC,gBAAgB;AACtF,cAAc,SAAS,CAAC,OAAO,CAAC,QAAQ;AACxC,gBAAgB,iBAAiB,CAAC,cAAc,CAAC,KAAK,CAAC,MAAM,CAAC,OAAO,CAAC,QAAQ,CAAC,qCAAqC,CAAwB,cAAc,CAAC,kBAAkB;AAC7K,uBAAuB,iBAAiB,CAAC,UAAU,CAAC,WAAW,CAAC,UAAU,CAAC,QAAQ,CAAC,UAAU,CAAC,iDAAiD,CAAwB,cAAc,CAAC,iBAAiB;AACxM,gCAAgC,qCAAqC;AACrE,uCAAyG,0BAA0B;;AAEnI,UAAU,SAAS,CAAC,uBAAuB,CAAC,iBAAiB;AAC7D,WAAW,sCAAsC,CAAC,eAAe,CAAC,cAAc,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,eAAe,CAAC,sBAAsB,CAAC;AAC1K,aAAa,gBAAgB,CAAC,cAAc,CAAC,sCAAsC;;AAEnF,QAAQ,iCAAiC,CAAC,gCAAgC,CAAC,iBAAiB,CAAC;AAC7F,SAAS,+BAA+B,CAAC,WAAW,CAAC,UAAU,CAAC,iBAAiB,CAAC,qBAAqB,CAAC,kCAAkC,CAAC,gJAAgJ,CAAC,2BAA2B;;AAEvT,SAAS;AACT,UAAU,+BAA+B,CAAC,6BAA6B;AACvE,iBAAiB,mFAAmF,CAAC,gCAAgC;AACrI,yBAAyB,+BAA+B,CAAC,gBAAgB,CAAC,oBAAoB,EAAE,iBAAiB,CAAC,6BAA6B;AAC/I,aAAa,YAAY,CAAC,6BAA6B,CAAC,iBAAiB,CAAC,mBAAmB,CAAC;AAC9F,eAAe,gCAAgC;AAC/C,iBAAiB,WAAW,CAAC,aAAa;AAC1C,sBAAsB,wCAAwC;;AAE9D,SAAS;AACT,UAAU,gBAAgB,CAAC,eAAe;AAC1C,cAAc,eAAe,CAAC;AAC9B,kBAAkB,iBAAiB;AACnC,gBAAgB,cAAc,CAAC,sCAAsC;AACrE,qBAAqB,SAAS,CAAC,gBAAgB;;AAE/C,UAAU;AACV,iBAAiB,UAAU;AAC3B,aAAa,0BAA0B,CAAC,wBAAwB,CAAC,gBAAgB,CAAC,kBAAkB,CAAC,cAAc;;AAEnH,gBAAgB,2BAA2B,CAAC,yBAAyB,CAAC,WAAW,CAAC,YAAY,CAAC,cAAc,CAAC,yBAAyB,CAAC,iBAAiB,CAAC,mBAAmB;AAC7K,0BAA0B,WAAW,CAAC,aAAa,CAAC,gBAAgB;AACpE,sBAAsB,mCAAmC,CAAC,2BAA2B,CAAC,iBAAiB,CAAC,oCAAoC;AAC5I,wBAAwB,gBAAgB,CAAC,sBAAsB;;AAE/D,yBAAyB,gBAAgB,CAAC,KAAK;AAC/C,wBAAwB,aAAa;AACrC,cAAc,kBAAkB;AAChC,sBAAsB,UAAU,CAAC,oBAAoB,CAAC,iBAAiB,CAAC,gCAAgC,CAAC;AACzG,oBAAoB,cAAc,CAAC,6BAA6B,CAAC;AACjE,kBAAkB,WAAW;AAC7B,wCAAwC,oCAAoC;;AAE5E,oDAAoD;AACpD,cAAc,YAAY,CAAC,eAAe,CAAC,aAAa,CAAC,YAAY,CAAC,qBAAqB,CAAC,kBAAkB,CAAC,kBAAkB;AACjI,SAAS,WAAW,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,iBAAiB;AAC3F,4BAA4B,SAAS;AACrC,kCAAkC,sBAAsB;AACxD,kCAAkC,wBAAwB,CAAC,iBAAiB;;AAE5E,eAAe,SAAS,CAAC,YAAY,CAAC,kBAAkB,CAAC,WAAW,CAAC,WAAW,CAAC,+BAA+B,CAAC,wBAAgB,CAAhB,gBAAgB,CAAC,WAAW;AAC7I,2BAA2B,kBAAkB,CAAC,cAAc,CAAC,iBAAiB,CAAC,WAAW,CAAC,UAAU,CAAC,cAAc,CAAC,qBAAqB,CAAC,iBAAiB,CAAC,iBAAiB;AAC9K,uBAAuB,gBAAgB,CAAC,WAAW;AACnD,qCAAqC,eAAe,CAAC,WAAW;;AAEhE,QAAQ,iBAAiB,CAAC,gBAAgB,CAAC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,yBAAyB,CAAC,gEAA+D,CACxK,6GADyK;AAEjL,6BAA6B,UAAU,CAAC,iBAAiB,CAAC,QAAQ,CAAC,0BAA0B;AAC7F,eAAe,KAAK,CAAC,SAAS,CAAC,WAAW,CAAC,wBAAwB,CAAC,2BAA2B;AAC/F,8BAA8B,iBAAiB,CAAC,aAAa,CAAC,iBAAiB;AAC/E,UAAU,KAAK,CAAC,QAAQ,CAAC,6BAA6B,CAAC,UAAU,CAAC,SAAS,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,kDAAkD;AACzK,UAAU,QAAQ,CAAC,KAAK,CAAC,8BAA8B,CAAC,UAAU,CAAC,WAAW,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,kDAAkD;AAC7K,gBAAgB,UAAU,CAAC,iBAAiB,CAAC,wBAAwB,CAAC,SAAS,CAAC,UAAU,CAAkB,OAAO,CAAC,QAAQ,CAAC,aAAa,CAAC,iBAAiB,CAAC,0CAA0C;;AAEvM,WAAW,8BAA8B;AACzC,QAAQ,QAAM,CAAC,iBAAiB,CAAC,YAAY,CAAC,YAAY,CAAC,qBAAqB,CAAC,eAAe,CAAC,eAAe;AAChH,eAAe,YAAY,CAAC,QAAQ,CAAC,oCAAoC,CAAC,YAAY,CAAC,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,WAAW,CAAC,mBAAmB,CAAC,iBAAiB,CAAC,iBAAiB,CAAC,gBAAgB;AAC1M,sBAAsB,UAAU;AAChC,oBAAoB,YAAY,CAAC,qBAAqB;AACtD,kBAAkB,UAAU,CAAC,mBAAmB;AAChD,QAAQ,iBAAiB,CAAC,YAAY;AACtC,wBAAwB,WAAW,CAAC;AACpC,QAAQ,gBAAgB,CAAC,UAAU,CAAC,WAAW,CAAC,YAAY;AAC5D,kCAAkC,SAAS;AAC3C,wCAAwC,sBAAsB;AAC9D,wCAAwC,wBAAwB,CAAC,iBAAiB;;AAElF,iGAAiG,kBAAkB;;AAEnH,WAAW,wBAAwB;;AAEnC,UAAU,UAAU,CAAC,eAAe,CAAC,iBAAiB;AACtD,gBAAgB,YAAY,CAAC,UAAU,CAAC,2BAA2B;AACnE,oBAAoB,UAAU,CAAC,aAAa;;AAE5C,mBAAmB,KAAK,8BAA8B,CAAC,GAAG,4BAA4B,CAAC;AACvF;IACI,OAAO,wBAAwB;IAC/B,QAAQ,2BAA2B;IACnC,SAAS,2BAA2B;AACxC;AA5QA;EAAA,oBA6QA;EA7QA;AA6QA;AA7QA;EAAA,iBA6QA;EA7QA,iBA6QA;EA7QA;AA6QA;AA7QA;EAAA,kBA6QA;EA7QA;AA6QA;AA7QA;EAAA,kBA6QA;EA7QA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;EAAA;AA6QA;AA7QA;;EAAA;IAAA,oBA6QA;IA7QA;EA6QA;;EA7QA;IAAA,iBA6QA;IA7QA;EA6QA;;EA7QA;IAAA,eA6QA;IA7QA;EA6QA;;EA7QA;IAAA,mBA6QA;IA7QA;EA6QA;AAAA;AA7QA;;EAAA;IAAA;EA6QA;;EA7QA;IAAA,kBA6QA;IA7QA;EA6QA;;EA7QA;IAAA;EA6QA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import './themes.css';\n\n@font-face{font-family:'Red Hat Display';font-style:italic;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIh7wUr0m80wwYf0QCXZzYzUoTg-CSvZX4Vlf1fe6TVmgsD9F-esXnZG0mHlPI&skey=75da5a29d105ef1f&v=v19) format(\"woff\");unicode-range:U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF}\n@font-face{font-family:'Red Hat Display';font-style:italic;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIh7wUr0m80wwYf0QCXZzYzUoTg-CSvZX4Vlf1fe6TVmgsD-l-esXnZG0mH&skey=75da5a29d105ef1f&v=v19) format(\"woff\");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}\n@font-face{font-family:'Red Hat Display';font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbmyWQkEz_lWZk33BGmGH&skey=3445dd5b86d56e57&v=v19) format(\"woff\");unicode-range:U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF}\n@font-face{font-family:'Red Hat Display';font-style:normal;font-weight:400;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbmyWQk8z_lWZk33BGg&skey=3445dd5b86d56e57&v=v19) format(\"woff\");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}\n@font-face{font-family:'Red Hat Display';font-style:italic;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIh7wUr0m80wwYf0QCXZzYzUoTg-CSvZX4Vlf1fe6TVfQwD9F-esXnZG0mHlPI&skey=75da5a29d105ef1f&v=v19) format(\"woff\");unicode-range:U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF}\n@font-face{font-family:'Red Hat Display';font-style:italic;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIh7wUr0m80wwYf0QCXZzYzUoTg-CSvZX4Vlf1fe6TVfQwD-l-esXnZG0mH&skey=75da5a29d105ef1f&v=v19) format(\"woff\");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}\n@font-face{font-family:'Red Hat Display';font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbouRQkEz_lWZk33BGmGH&skey=3445dd5b86d56e57&v=v19) format(\"woff\");unicode-range:U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF}\n@font-face{font-family:'Red Hat Display';font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/l/font?kit=8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbouRQk8z_lWZk33BGg&skey=3445dd5b86d56e57&v=v19) format(\"woff\");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}\n\n/* font-family:'Gilroy', sans-serif; */\nhtml,body{height:100%;margin:0;padding:0}\nbody{background:#F2F7FF 100%;color:#25396f;font-size:16px;font-family:'Red Hat Display', sans-serif}\nmain{margin-top:-120px}\n#root{height:100%;display:flex;flex-direction:column}\n\n.color-primary{color:#012388}\n.app-secondary{color:var(--color-secondary)}\n.app-secondary-container{color:var(--color-secondary-container)}\n.bg-primary{background:#012388}\n\n/* Header */\n.header{padding-bottom:100px}\n.top > div{border-bottom:1px solid rgb(108, 142, 194, 0.2)}\n.zasmedia{max-width:200px}\n.steps .step{color:#fff;font-weight:400 !important;min-width:100px}\n.steps .step:before, .steps .step:after {background:rgb(108, 142, 194);color:#012388}\n.steps .step-primary + .step-primary:before, .steps .step-primary:after {background:#fff}\n\n/* Structure */\n.content{background:#fff;border-radius:12px;padding:48px;min-height:800px}\n.content9{min-height:900px}\n.content.col{padding:36px}\n.max-w-7xl{max-width:90rem}\n.dash{width:100%;height:100%;border-radius:12px;border:1px dashed #ccc;stroke:color-mix(in oklab, #ccc 30%, transparent);inset:calc(0.25rem * 0);position:absolute;display: block;}\n.dash-over{position:absolute;z-index:1}\n\n.horizontal{display:flex;overflow-x:auto;gap:20px;padding:10px;white-space:nowrap;scrollbar-width:thin;scrollbar-color: gray transparent}\n.horizontal .mockup-phone{min-width:348px}\n.horizontal::-webkit-scrollbar{height:6px}\n.horizontal::-webkit-scrollbar-thumb{background:#ff9920;border-radius:10px}\n.horizontal::-webkit-scrollbar-track{background:transparent}\n\n.collapse{border:1px solid #d2d5dc;margin-top:2rem}\n.collapse-title{font-weight:700}\n\n.colors-scroll{overflow-x:scroll;max-height:500px;overflow-x:hidden;overflow-y:scroll}\n.colors-scroll::-webkit-scrollbar{width:8px}\n.colors-scroll::-webkit-scrollbar-track{background:transparent}\n.colors-scroll::-webkit-scrollbar-thumb{background-color:#ff9920;border-radius:4px}\n\n/* ==================== */\n/*  Mobile\n/* ==================== */\n.mockup-crop{max-height:250px;overflow:hidden}\n.mockup-crop.bar{max-height:150px}\n.mockup-phone{font-family:'Gilroy', sans-serif;text-wrap: wrap;}\n.mockup-phone .camera::before, .mockup-phone .camera::after{display:none}\n\n.artboard{color:var(--color-text)}\n.artboard.phone-1, .mockup-phone .display{height:650px}\n.artboard.phone-7{width:450px;height:900px}\n.artboard.apps{display:grid;gap:10px;grid-template-columns:repeat(4, 1fr);justify-content:center;align-content:start;text-align:center;padding:40px 15px 0}\n.artboard.apps span{color:#fff;font-size:13px;line-height:13px;text-shadow:1px 1px 1px rgba(0, 0, 0, .5);display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;max-height:3em;}\n.artboard .icon{max-width:86px;display:flex;flex-direction:column;align-items:center;justify-content:start}\n.artboard .icon img, .artboard .bg-icon{width:50px;border-radius:12px;margin-bottom:5px}\n.artboard .bg-icon img{margin:0}\n\n.submit-icon .app-icon{max-width:92px;border-radius:12px;border:1px solid #ccc}\n.store{width:320px;min-height:300px;padding:40px 20px 20px}\n.store .icon{margin-right:20px}\n.store .app-icon{width:60px;border-radius:12px;border:1px solid #ccc;flex-grow:1}\n.store .app-store-title{font-size:1.25rem;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;line-clamp:2;-webkit-box-orient:vertical}\n.app-store .app-icon{width:90px}\n.app-store .icon{margin-right:10px}\n.app-gradient{background:url('assets/app-bg.jpg');background-size:100% 100%}\n\n.app-bg{background:radial-gradient(circle at 50% 40%, var(--color-background-center) 0%, var(--color-background) 100%)}\n.app-intro{height:65%}\n.app-intro img, .app-radio .logo img{max-width:70%;max-height:60%;height:auto;width:auto;object-fit:contain}\n.app-radio .logo img{max-height:90%}\n.app-more{background:color-mix(in oklab, #000 20%, var(--color-primary));}\n\n.topbar{background:var(--color-primary-dark);color:var(--color-system);border-radius:38px 38px 0 0;display:flex;justify-content:space-between;padding:10px 30px}\n.topbar i + i{padding-left:10px}\n\n.appbar{background:var(--color-primary);padding:8px 10px;box-shadow:0 2px 2px rgba(0,0,0,0.1);display:flex;justify-content:space-between;align-items:center}\n.appbar i{font-size:24px;color:var(--color-on-primary)}\n.appbar i + i{padding-left:15px}\n.appbar-logo{max-height:40px}\n\n.icon-box{display:flex;padding:12px 0;flex-direction:column;align-items:center;font-weight:700;font-size:16px;color:var(--color-on-surface)}\n.icon-box i{font-size:32px;margin-bottom:10px}\n\n.navbar{background:var(--color-tab);display:flex;justify-content:space-between;color:var(--color-on-tab);border-radius:0 0 38px 38px;min-height:3rem;padding:8px 20px}\n.navbar .icon-box.active{color:var(--color-tab-primary)}\n.navbar .icon-box{padding:10px 0 10px;color:var(--color-on-tab)}\n.navbar .icon-box i{font-size:22px}\n.navbar .icon-box.svg{padding-top:4px}\n.navbar .icon-box.svg svg{margin-bottom:4px;width:34px;height:34px}\n.navbar .spacer{width:auto;height:77px}\n.navbar .canvas-field{max-width:25%;text-align:center}\n.navbar .shrink{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%}\n\n.app-mini .topbar{font-size:12px}\n.app-mini .appbar-logo{max-height:30px}\n\n.app-mini .appbar i{font-size:18px}\n.app-mini .navbar{padding:2px 20px 8px;line-height:8px}\n.app-mini .navbar .icon-box i{font-size:18px}\n.app-mini .navbar .icon-box.svg{padding-top:2px}\n.app-mini .icon-box{font-size:12px;padding:8px 0 6px}\n.app-mini .icon-box.svg svg{margin-bottom:4px}\n\n/* Home */\n.app-home{max-height:504px;padding:15px 10px 10px;overflow:hidden}\n\n/* Elements */\n.artboard .el, .canvas-fields .el, .spacer{background:color-mix(in srgb, var(--color-surface) 60%, transparent);color:var(--color-on-surface);box-shadow:4px 4px 4px rgba(0,0,0,0.1);border-radius:6px;position:relative}\n.space{color:transparent !important}\n.spacer.full{grid-column:span 3}\n.canvas-fields .shrink{font-size:14px}\n\n.app-home > .el + .el{margin-top:10px}\n.dash-tv{display:flex;align-items:center}\n.dash-tv img{width:45%;border-radius:6px}\n.dash-tv > div{flex:1;min-width:0;padding:0 15px}\n.dash-tv strong{font-size:20px;line-height:20px;display:block;font-weight:700;color:var(--color-secondary);margin-bottom:5px}\n.dash-tv div span{font-size:16px;line-height:18px;display:inline-block;}\n\n.wrap{display:block;word-wrap:break-word;overflow-wrap:break-word;white-space:normal}\n\n.hList{width:435px;overflow:hidden}\n.hList .topEl{display:flex;justify-content:space-between;margin-bottom:15px;align-items:center;margin-right:15px}\n.hList .topEl span{font-weight:700;color:var(--color-hint)}\n.hList .topEl button{background:var(--color-hint);;border:none;color:var(--color-background);padding:6px 8px;font-size:12px;border-radius:6px}\n.hList ul{width:600px;margin:0;padding:0;display:flex;flex-wrap:nowrap;overflow-x:auto;overflow-y:hidden}\n.hList ul li{width:28%;margin-right:15px;list-style:none}\n.hList ul li img{width:100%}\n.hList ul li span{display:-webkit-box;-webkit-line-clamp:2;line-clamp:2;-webkit-box-orient:vertical;font-size:16px;font-weight:700;margin-top:10px;color:var(--color-highlight)}\n\n.app-mini .hList{width:315px;margin-top:10px}\n.app-mini .hList .topEl{margin-bottom:10px}\n.app-mini .hList .topEl button{font-size:10px;padding:4px 6px}\n.app-mini .hList ul li span{font-size:13px;margin-top:8px}\n.app-mini .app-home .icon-box{font-size:12px;padding:12px 0 10px}\n.app-mini .app-home .icon-box i{font-size:24px;margin-bottom:4px}\n.app-mini .dash-tv strong{font-size:16px}\n.app-mini .dash-tv div span{font-size:13px}\n\n.tabs, .app-more .el{background:transparent;box-shadow:none}\n.tabs input{color:var(--color-primary-light);position:relative;;z-index:1;padding:5px 16px;height:38px;font-weight:700}\n.tabs input:first-child::before{background:var(--color-primary);width:400px;height:35px;content:\"\";position:absolute;top:0;left:0;z-index:-1}\n.tabs-border .tab{border-bottom:3px solid var(--color-primary)}\n.tabs-border .tab:is(input:checked){color:var(--color-on-primary);border-color:var(--color-primary-container)}\n.tab-content{max-width:320px}\n.app-tv .tab-content{max-height:287px;overflow:hidden}\n\n.share{font-size:14px;border:1px solid rgba(255,255,255,0.2);padding:8px 10px;border-radius:6px;color:var(--color-secondary-container)}\n.share li{width:20px;height:20px;border-radius:50%;margin-left:5px;padding:0 0 1px 3px}\n.share li i{font-size:12px;color:#fff}\n.share .icon-wa{background:#3EC351;padding:0 0 1px 5px}\n.share .icon-fb{background:#4166B1}\n.share .icon-sh{background:#006E62}\n.share .icon-x{background:#000}\n.share .icon-ma{background:#006ab1}\n\n.programs .el img{width:35%;border-radius:6px;margin-right:10px}\n.programs .info{font-size:10px;color:var(--color-secondary-container)}\n\n.switch{position:relative;display:inline-block;width:30px;height:17px;margin-left:10px}\n.switch input{opacity:0;width:0;height:0}\n.switch .slider{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;border:1px solid var(--color-divider);-webkit-transition:.4s;transition:.4s;border-radius:34px}\n.switch .slider:before{position:absolute;content:\"\";height:13px;width:13px;left:2px;bottom:1px;background-color:var(--color-secondary-container);-webkit-transition:.4s;transition:.4s;border-radius:50%}\n.switch input:checked + .slider{background-color:var(--color-primary)}\n.switch input:checked + .slider:before{-webkit-transform:translateX(13px);-ms-transform:translateX(13px);transform:translateX(13px)}\n\n.dev-date{width:12%;color:var(--color-hint);margin-right:10px}\n.dev-verse{color:var(--color-secondary-container);max-width:230px;font-size:11px;border-radius:6px;padding:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}\n.dev-chapter{text-align:right;font-size:11px;color:var(--color-secondary-container)}\n\n.button{background:var(--color-secondary);color: var(--color-on-secondary);border-radius:6px;}\n.shimmer{background:var(--color-shimmer);height:80px;width:80px;border-radius:6px;animation: shimmer 3s;animation-iteration-count:infinite;background:linear-gradient(to right, var(--color-shimmer) 5%, color-mix(in srgb, var(--color-shimmer) 50%, white) 25%, var(--color-shimmer) 35%);background-size:1000px 100%}\n\n/* Menu */\n.app-menu{background:var(--color-primary);color:var(--color-on-primary)}\n.app-menu .login{background:color-mix(in srgb, var(--color-primary) 90%, var(--color-primary-light));color:var(--color-primary-light)}\n.app-menu .login .circle{background:var(--color-primary);padding:8px 13px;display:inline-block; border-radius:50%;color:var(--color-on-primary)}\n.app-menu li{display:flex;justify-content:space-between;padding:15px 15px;align-items: center;}\n.app-menu li i{color:var(--color-primary-light)}\n.app-menu li div{flex-grow:1;margin:0 20px}\n.app-menu .border-top{border-top:1px solid var(--color-canvas)}\n\n/* News */\n.app-news{max-height:504px;overflow:hidden}\n.app-news .el{border-radius:0;}\n.app-news .el img{border-radius:6px}\n.app-news .info{font-size:12px;color:var(--color-secondary-container)}\n.app-news .horiz img{width:30%;object-fit:cover}\n\n/* Radio */\n.app-radio .logo{height:40%}\n.playing-now{background:var(--color-bg);color:var(--color-on-bg);padding:5px 20px;border-radius:20px;font-size:12px}\n\n.radio-controls{background:var(--color-tab);color:var(--color-on-tab);width:400px;height:200px;font-size:24px;border-radius:50% 50% 0 0;margin-left:-40px;margin-bottom:-50px}\n.radio-controls .controls{width:220px;margin:0 auto;padding-top:35px}\n.radio-controls .play{background:var(--color-tab-primary);padding:25px 29px 22px 33px;border-radius:50%;box-shadow:0 5px 10px rgba(0,0,0,.1)}\n.radio-controls .play i{font-size:2.5rem;color:var(--color-tab)}\n\n.app-more .canvas-fields{padding:15px 0 0;gap:0}\n.app-more .canvas-field{padding:5px 0}\n.app-more .el{flex-direction:row}\n.app-more .icon-box i{width:40px;margin:0 30px 0 30px;text-align:center;color:var(--color-primary-light);}\n.app-more .icon-box{font-size:20px;color:var(--color-on-primary);}\n.app-more .spacer{height:50px}\n.app-more .canvas-field + .canvas-field{border-top:2px solid rgba(0,0,0, .2)}\n\n/* .app{background:red;width:1100px;margin:0 auto} */\n.sidebar-wrap{height:900px;font-weight:700;color:#172b4c;display:flex;flex-direction:column;align-items:center;border-radius:10px}\n.sidebar{width:300px;overflow-x:scroll;max-height:840px;overflow-x:hidden;overflow-y:scroll}\n.sidebar::-webkit-scrollbar{width:8px}\n.sidebar::-webkit-scrollbar-track{background:transparent}\n.sidebar::-webkit-scrollbar-thumb{background-color:#ff9920;border-radius:4px}\n\n.sidebar-field{all:unset;display:flex;align-items:center;height:50px;width:250px;border-bottom:1px solid #e0e4f4;user-select:none;padding:5px}\n.sidebar-field-drag-handle{background:#ff9920;min-width:42px;border-radius:6px;cursor:grab;color:#fff;font-size:20px;padding:10px 10px 4px;margin-right:10px;text-align:center}\n.sidebar-field.overlay{background:white;color:white}\n.disabled .sidebar-field-drag-handle{background:#ccc;cursor:auto}\n\n.device{position:relative;margin:40px auto;width:450px;height:900px;border-radius:40px;color:var(--color-system);box-shadow:0 0 0 11px #1f1f1f,0 0 0 13px #191919,0 0 0 20px #111}\n.device{background:radial-gradient(circle at 50% 40%, var(--color-background-light) 0%, var(--color-background) 100%)}\n.device:before,.device:after{content:\"\";position:absolute;left:50%;transform:translateX(-50%)}\n.device:before{top:0;width:56%;height:30px;background-color:#1f1f1f;border-radius:0 0 40px 40px}\n.device s,.device b,.device s{position:absolute;display:block;color:transparent}\n.device s{top:0;left:50%;transform:translate(-50%,6px);height:8px;width:15%;background-color:#101010;border-radius:8px;box-shadow:inset 0 -3px 3px 0 rgba(255,255,255,.2)}\n.device b{left:10%;top:0;transform:translate(180px,4px);width:12px;height:12px;background-color:#101010;border-radius:12px;box-shadow:inset 0 -3px 2px 0 rgba(255,255,255,.2)}\n.device b:after{content:\"\";position:absolute;background-color:#2d4d76;width:6px;height:6px;top:2px;left:2px;top:3px;left:3px;display:block;border-radius:4px;box-shadow:inset 0 -2px 2px rgba(0,0,0,.5)}\n\n.canvas-bg{background:var(--color-canvas)}\n.canvas{flex:1;border-radius:5px;padding:10px;display:flex;flex-direction:column;max-height:100%;overflow-y:auto}\n.canvas-fields{display:grid;gap:15px;grid-template-columns:repeat(3, 1fr);padding:15px;position:absolute;top:0;left:0;right:-15px;padding-bottom:20px;overflow-x:hidden;overflow-y:scroll;max-height:710px}\n.canvas-field.overlay{opacity:.5}\n.canvas-fields.flex{display:flex;flex-direction:column}\n.canvas-field > *{width:100%;pointer-events:none}\n.screen{position:relative;height:710px}\n.screen-opacity .screen{opacity:0.2;}\n.spacer{background:white;width:100%;opacity:.25;height:100px}\n.canvas-fields::-webkit-scrollbar{width:8px}\n.canvas-fields::-webkit-scrollbar-track{background:transparent}\n.canvas-fields::-webkit-scrollbar-thumb{background-color:#e7b40d;border-radius:4px}\n\n.image, .slider, .tv_full, .news_full, .videos, .youtube_videos_full, .donate_full, .next_events{grid-column:span 3}\n\n.outline-1{border:1px solid #e8e8e8}\n\n.carousel{width:100%;overflow:hidden;position:relative}\n.carousel-track{display:flex;width:300%;animation:slide 9s infinite}\n.carousel-track img{width:100%;flex:1 0 100%}\n\n@keyframes shimmer{from{background-position: -1000px 0}to{background-position:1000px 0}}\n@keyframes slide {\n    0%,33%{transform:translateX(0%)}\n    34%,66%{transform:translateX(-100%)}\n    67%,100%{transform:translateX(-200%)}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
